import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ActivatedRoute, Router } from '@angular/router';
import * as printJS from 'print-js';
import { Store } from 'src/app/models/store';
import { Client } from "src/app/models/client";
import { Company } from "src/app/models/company";
import { StoreService } from 'src/app/services/store.service';
import { ClientService } from 'src/app/services/client.service';
import { CompanyService } from 'src/app/services/company.service';
import { InventoryService } from 'src/app/services/inventory.service';
import { InvoiceHeader } from '../../../../models/invoiceHeader';
import { InvoiceDetail } from '../../../../models/invoiceDetail';
import { InvoiceService } from 'src/app/services/invoice.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { DatePipe, DecimalPipe } from '@angular/common';
import { LetrasPipe } from 'src/app/pipe/letras/letras.pipe';
import { UtilsService } from 'src/app/services/utils.service';
import swal from "sweetalert2";
import { PrintService } from 'src/app/services/print.service';
declare var QRCode: any;


import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Console } from 'console';
import { ConnectableObservable } from 'rxjs';

@Component({
  selector: 'app-inventory-exenta-billing',
  templateUrl: './inventory-exenta-billing.component.html',
  styleUrls: ['./inventory-exenta-billing.component.scss'],
  providers: [ClientService, StoreService, CompanyService, InventoryService, InvoiceService, WarehouseService, UtilsService, PrintService]
})
export class InventoryExentaBillingComponent implements OnInit {
  // Variables auxiliares
  pipeLetra = new LetrasPipe();
  pipeFecha = new DatePipe('en-US');
  store = {} as Store;
  client = {} as Client;
  company = {} as Company;
  invoiceHeader = {} as InvoiceHeader;
  invoiceDetail = {} as InvoiceDetail;
  public nowDay: string;
  public userCode: number;
  public userName: string;
  public storeCode: number;
  public storeName: string;
  public companyCode: number;
  public companyTaxCode: string;
  public companyAddDescription: number | boolean;
  public companyInventoryView: number;
  public companyExentaInvoice: number  | boolean;
  public companySendStock: number | boolean;
  public companyAddressNotif: number;
  public files = {};
  public temp = [];
  loading;

  public isBeginning: boolean;
  public isBilling: boolean;
  public isPrintT: boolean;
  public isPrintL: boolean;
  public isEdit: boolean;
  public isDisabled: boolean;
  public recurrentClient: boolean;
  public insertNewClient: boolean = false; //crear cliente si no existe
  public activeRow: any;
  public isInventoryView: boolean;

  // DATA SELECT
  public id: number;
  public itemName: string;
  public selectedItems = [];
  public inventoryList: any[] = new Array();
  public dropdownSettings: IDropdownSettings = {};
  closeDropdownSelection = false;
  //public dropdownSettingsProduct = {};

  // DATA SELECT SERIAL
  public selectedItemsSerial = [];
  public serialList: any[] = new Array();
  public dropdownSettingsSerial: IDropdownSettings = {};
  closeDropdownSelectionSerial = false;
  public serialSelected = new Array;
  public serialSelectedTemp = new Array;

  // Variables de Linea de Compra
  public itemCode: string;
  public stock: number;
  public Minstock: number;
  public moneda: string;
  public invoiceLine: any = new Array;
  public invoiceLineMinStock: any = new Array;
  public addAmount: boolean;
  public idp: number;
  public subIdp: number;
  public subsidio: number;
  public subsidioTemp: number;
  public isOil: number;
  public petroleo: string;
  public taxOilCode: number;
  public taxOilAmount: number;
  public dte: any;
  public fel: any;
  public felDetail: any;
  public priceType: number;
  public companyLogoUrl: string;
  public taxToPay: number = 0
  public regimenMessage: string = '';

  //FACTURAR DESDE CLIENT
  public code: number = 0;
  public url: any;
  activatedRoute: ActivatedRoute | null | undefined;

  //FACTURA DESDE TRANSFERENCIA
  public isParamsUrl: boolean = false;
  public transferCode: any;
  public transferDetail: any[];
  public total: number;

  //Prueba de impresion
  public infile: any;
  public megaprint: any;

  public disabled = false;
  public disabledEXT = false;
  public facturando: boolean;

  public tipoCliente = 0;
  public tipoPago = 0;
  public OrdenCompra = "0";
  public entries: number = 10;

  // DATA SELECT PAYMENT
  public idPayment: number;
  public itemNamePayment: string;
  public selectedItemsPayment = [];
  public PaymentList: any[] = new Array();
  public dropdownSettingsPayment: IDropdownSettings = {};
  closeDropdownSelectionPayment = false;

  // DATA SELECT ADDRESS CLIENT
  public idProvincia: number;
  public itemNameProvincia: string;
  public selectedItemsProvincia = [];
  public ProvinciaList: any[] = new Array();
  public dropdownSettingsProvincia: IDropdownSettings = {};
  closeDropdownSelectionProvincia = false;

  public idDistritos: number;
  public itemNameDistritos: string;
  public selectedItemsDistritos = [];
  public DistritosList: any[] = new Array();
  public dropdownSettingsDistritos: IDropdownSettings = {};
  closeDropdownSelectionDistritos = false;

  public idCorregimientos: number;
  public itemNameCorregimientos: string;
  public selectedItemsCorregimientos = [];
  public CorregimientosList: any[] = new Array();
  public dropdownSettingsCorregimientos: IDropdownSettings = {};
  closeDropdownSelectionCorregimientos = false;

  public modeClient: boolean = false;

  // FIN DATA SELECT ADDRESS CLIENT
  
  public PaymentLine: any = new Array;
  public PaymentType = 0;
  public NamePaymentType = 0;
  public MontoPayment: number = 0.00;
  public MontoTotalPayment: number = 0.00;
  public Autorizacion: string = "0";
  public disabledPay = false;
  public isDisabledInvoice = false;
  public isMethodPay = false;

  // DATA SELECT SALES PERSON
  public selectedItemsSalesP = [];
  public SalesPList: any[] = new Array();
  public dropdownSettingsSalesP: IDropdownSettings = {};
  //public dropdownSettingsSalesP = {};
  closeDropdownSelectionSalesP = false;
  public SalesPerson = 0;
  public OpenCash: boolean;
  public ExentaInvoice: number | boolean;

  public qrBase64: string = '';
  private TotalLetras: string = "";

  constructor(
    private _utilsService: UtilsService,
    private _storeService: StoreService,
    private _clientService: ClientService,
    private _companyService: CompanyService,
    private _invoiceService: InvoiceService,
    private _inventoryService: InventoryService,
    private _warehouseService: WarehouseService,
    private cdref: ChangeDetectorRef,
    private router: Router,
    private _pipeNumero: DecimalPipe,
    private _printService: PrintService,
  ) { 
  }

  async ngOnInit() {
    this.isInventoryView = false;
    this.addAmount = true;
    this.isEdit = false;
    this.isDisabled = false;
    this.disabled = false;
    this.jumpSerial = false;
    this.insertNewClient = false;
    this.idp = 0;
    this.subIdp = 0;
    this.subsidio = 0;
    this.subsidioTemp = 0;
    this.taxToPay = 0;
    this.moneda = "₲";
    this.priceType = 1;
    this.petroleo = null;
    this.taxOilAmount = 0;
    this.taxOilCode = null;
    this.invoiceHeader.invoiceIDP = 0;
    this.invoiceHeader.invoiceCoin = 0;
    this.invoiceHeader.invoiceTax = 0;
    this.invoiceHeader.invoiceTotal = 0;
    this.invoiceHeader.invoiceCurrency = 'PAB';
    this.invoiceDetail.invoiceDetailType = 'B';
    this.invoiceDetail.invoiceDetailQuantity = 1;
    this.invoiceHeader.invoiceInternSerial = 'A';
    this.invoiceHeader.paymentType = 0;
    this.invoiceHeader.invoiceExchangeRate = 0;
    this.tipoPago = 0;
    this.invoiceHeader.invoiceCommentInvoice = "";

    this.nowDay = this._utilsService.dateTime('yyy-MM-dd');
    this.invoiceHeader.invoiceDate = this.nowDay;

    // GET ID USER & ID COMPANY
    const _data = JSON.parse(localStorage.getItem('data'));
    this.storeName = _data.storeName ? _data.storeName.toString() : null;
    this.userCode = _data.userCode ? parseInt(_data.userCode.toString()) : 0;
    this.storeCode = _data.storeCode ? parseInt(_data.storeCode.toString()) : 0;
    this.companyCode = _data.companyCode ? parseInt(_data.companyCode.toString()) : 0;
    const _user = JSON.parse(localStorage.getItem('user'));
    this.userName = _user.userName ? _user.userName.toString() : '';
    this.invoiceHeader.invoiceInternSerial = _user.userSerial ? _user.userSerial.toString() : 'A';

    this.loading = true;
    this.viewBeginning();    
    await this.getStore(this.storeCode);
    await this.getCompany(this.companyCode);

    console.log('companyInventoryUnique',this.company.companyInventoryUnique);
    console.log('companyInventoryStoreCode',this.company.companyInventoryStoreCode);
    console.log('this.company.companyTaxDocument', this.company.companyTaxDocument);

    if(this.company.companyInventoryUnique == 1){
      console.log('storeCode Unique',this.company.companyInventoryStoreCode)
      await this.getInventoryList(this.company.companyInventoryStoreCode);
    }
    else{
      console.log('storeCode login',this.storeCode)
      await this.getInventoryList(this.storeCode);
    }
    //await this.getInventoryList(this.storeCode);

    await this.getSelectSetting(this.selectedItems);
    this.getSelectSettingSerial(this.selectedItemsSerial);

    await this.getSalesPList(this.storeCode);
    await this.getPaymetList(this.storeCode);    
    this.getSelectSettingPaymet(this.selectedItemsPayment);
    this.getSelectSettingSalesP(this.selectedItemsSalesP);    

    console.log('Select -> ', this.selectedItems);
    console.log('Select Tipo pagos -> ', this.selectedItemsPayment);
    console.log('Tipo pagos -> ', this.PaymentList);

    await this.getAddresClientList(1, 0);
    this.getSelectSettingProvincia(this.selectedItemsProvincia);

    this.OpenCash = this.company.companyOpenCash == 1 ? this.OpenCash = true : this.OpenCash = false;
    console.log('OpenCash -> ', this.OpenCash);

    await this.Pagado();

    this.SKUx = "";
    this.client.clientType = 0;
    this.client.clientTR = "0";
    this.tipoCliente = 0;
    this.disabledEXT = true;
    this.disabled = false;
    // console.log('CompanyCode-> ', this.companyCode);

    if(this.companyInventoryView == 1){
      this.isInventoryView = true;
      this.getAll(this.storeCode);
    }
    this.loading = false;

    this.url = this.router.parseUrl(this.router.url);
    if (this.url.queryParams['nit'] != undefined) {

      if (localStorage.getItem('clientData') !== null) {
        console.log('si hay data de cliente');
        this.modeClient = true;

        let _dataCli = JSON.parse(localStorage.getItem('clientData'));

        console.log('localstorage -> ', _dataCli.clientName);

        this.client.clientName = _dataCli.clientName;
        this.client.clientStatus = 1;
        this.client.clientDeleted = 0;
        this.client.clientPhone = _dataCli.clientPhone;
        this.client.clientEmail = _dataCli.clientEmail;
        this.client.clientAddress = _dataCli.clientAddress;
        this.client.clientCode =  _dataCli.clientCode;
        this.client.clientTaxDocument = _dataCli.clientTaxDocument;        
        this.tipoCliente = _dataCli.clientType;
        this.client.clientType = _dataCli.clientType;
        this.client.clientTR = _dataCli.clientTR;
        this.client.clientDV = _dataCli.clientDV;
        this.idProvincia = _dataCli.clientIdDepto;
        this.idDistritos = _dataCli.clientIdDistrito;
        this.idCorregimientos = _dataCli.clientIdCiudad;
        this.itemNameProvincia = _dataCli.clientDescDepto;
        this.itemNameDistritos = _dataCli.clientDescDistrito;
        this.itemNameCorregimientos = _dataCli.clientDescCiudad;
        this.client.clientAddress = _dataCli.clientAddress;
        // this.client.clientDV = _dataCli.clientAddress;

        console.log('CodDireccion ModeClient -> ', this.idProvincia, this.idDistritos, this.idCorregimientos);
        console.log('Descripcion ModeClient -> ', this.itemNameProvincia, this.itemNameDistritos, this.itemNameCorregimientos);

        this.viewBilling();
        this.loading = false;
        this.isDisabled =false;

        console.log('Cliente -> ', this.client);
        console.log('Tipo Cliente -> ', this.tipoCliente);
  
        this.insertNewClient = false;
        this.recurrentClient = true;
      }

      // this.isParamsUrl = true;
      // this.code = this.url.queryParams['nit'];
      // await this.buscarNITLocal(event, this.code);

      if (this.url.queryParams['transfer']) {
        let transfer = this.url.queryParams['transfer'];
        await this.cargarTrasnferencia(transfer);
      }

    } 
  }

  async onItemSelectPaymet(item: any) {
    console.log("---item---");
    console.log(item);
    const _selectedItemPayment = await this.PaymentList.find(x => x.id == item.id);
    console.log(_selectedItemPayment);

    this.tipoPago = item.payMethodBusinessCode;
    console.log('Tipo Pago -> ', this.tipoPago);

    this.PaymentType = this.tipoPago;
    this.NamePaymentType = item.payMethodName;
    // console.log('NamePaymentType', this.NamePaymentType);

    // this.itemCode = item.idPayment;
    // this.invoiceDetail.invoiceDetailDescription = item.itemNamePayment;
    // this.stock = _selectedItem.inventoryQuantity;
    // this.Minstock = _selectedItem.inventoryMin;
  }

  getPaymetList(code) {
    return this._storeService.getPaymets(code).then(
      response => {
        if (response.result) {
          this.PaymentList = response.records;
          // console.log("paymentList ->" + JSON.stringify(response.records));
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  getSelectSettingPaymet(selected) {
    // console.log(selected);
    Object.keys(selected).length > 0 ? this.selectedItemsPayment = [selected] : '';

    this.dropdownSettingsPayment = {
      singleSelection: true,
      searchPlaceholderText: 'Buscar...',
      closeDropDownOnSelection: true,
      allowSearchFilter: true,
      idField: 'payMethodBusinessCode',
      textField: 'payMethodName'
    };
  }

  getAddresClientList(type, code) {

    let addresC ={
      type: type,
      code: code
    }

    return this._clientService.getAddressClient(addresC).then(
      response => {
        if (response.result) {

          if (type == 1) {
            this.ProvinciaList = response.records;
            console.log("ProvinciaList ->" + JSON.stringify(response.records));
          }
          else if (type == 2) {
            this.DistritosList = response.records;
            console.log("DistritosList ->" + JSON.stringify(response.records));
          }
          else if (type == 3) {
            this.CorregimientosList = response.records;
            console.log("CorregimientosList ->" + JSON.stringify(response.records));
          }
          
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  async onItemSelectProvincia(item: any) {
    console.log("---item---");
    console.log(item);
    const _selectedItemProvincia = await this.ProvinciaList.find(x => x.cod_provincia == item.cod_provincia);
    console.log(_selectedItemProvincia);    

    this.idProvincia = item.cod_provincia;
    this.itemNameProvincia = item.nombre;

    await this.getAddresClientList(2, item.cod_provincia);
    this.getSelectSettingDistrito(this.selectedItemsDistritos);
  }

  async onItemSelectDistrito(item: any) {
    console.log("---item---");
    console.log(item);
    const _selectedItemDistrito = await this.DistritosList.find(x => x.id == item.id);
    console.log(_selectedItemDistrito);    

    this.idDistritos = item.cod_distrito;
    this.itemNameDistritos = item.nombre;

    await this.getAddresClientList(3, this.idProvincia);
    this.getSelectSettingCorregimiento(this.selectedItemsCorregimientos);
  }

  async onItemSelectCorregimiento(item: any) {
    console.log("---item---");
    console.log(item);
    const _selectedItemCorregimiento = await this.CorregimientosList.find(x => x.id == item.id);
    console.log(_selectedItemCorregimiento);    

    this.idCorregimientos = item.cod_corregimiento;
    this.itemNameCorregimientos = item.nombre;    

    console.log('CodDireccion -> ', this.idProvincia, this.idDistritos, this.idCorregimientos);
    console.log('Descripcion -> ', this.itemNameProvincia, this.itemNameDistritos, this.itemNameCorregimientos);
  }

  getSelectSettingProvincia(selected) {
    // console.log(selected);
    Object.keys(selected).length > 0 ? this.selectedItemsProvincia = [selected] : '';

    this.dropdownSettingsProvincia = {
      singleSelection: true,
      searchPlaceholderText: 'Buscar...',
      closeDropDownOnSelection: true,
      allowSearchFilter: true,
      idField: 'cod_provincia',
      textField: 'nombre'
    };
  }

  getSelectSettingDistrito(selected) {
    // console.log(selected);
    Object.keys(selected).length > 0 ? this.selectedItemsDistritos = [selected] : '';

    this.dropdownSettingsDistritos = {
      singleSelection: true,
      searchPlaceholderText: 'Buscar...',
      closeDropDownOnSelection: true,
      allowSearchFilter: true,
      idField: 'cod_distrito',
      textField: 'nombre'
    };
  }

  getSelectSettingCorregimiento(selected) {
    // console.log(selected);
    Object.keys(selected).length > 0 ? this.selectedItemsCorregimientos = [selected] : '';

    this.dropdownSettingsCorregimientos = {
      singleSelection: true,
      searchPlaceholderText: 'Buscar...',
      closeDropDownOnSelection: true,
      allowSearchFilter: true,
      idField: 'cod_corregimiento',
      textField: 'nombre'
    };
  }

  async addPaymetDetail(){

    this.MontoTotalPayment = parseFloat(((this.MontoTotalPayment + (this.MontoPayment))).toFixed(6));
    console.log(this.MontoTotalPayment);

    await this.PaymentLine.push({
      typePayment: this.PaymentType,
      NamePaymentType: this.NamePaymentType,
      MontoPayment: this.MontoPayment,
      Autorizacion: this.Autorizacion
    });

    this.MontoPayment = 0;
    this.Autorizacion = "0";
    this.selectedItemsPayment = [];

    this.Pagado();

    console.log(this.PaymentLine);
  }

  async deletePaymetDetail(item) {

    await this.PaymentLine.forEach(async (e, index) => {
      if (e.typePayment === item) {

        this.MontoTotalPayment = parseFloat(((this.MontoTotalPayment - (e.MontoPayment))).toFixed(6));        
        this.PaymentLine.splice(index, 1);
      }
    })

    this.Pagado();
        
    console.log(this.PaymentLine);
  }

  async Pagado(){

    console.log('MontoTotalPayment',this.MontoTotalPayment);
    console.log('invoiceTotal', parseFloat((this.invoiceHeader.invoiceTotal).toFixed(4)));

    if(this.company.companyPaymentType == 1){
      this.isMethodPay = true;
      if((this.MontoTotalPayment == parseFloat((this.invoiceHeader.invoiceTotal).toFixed(4))) && this.MontoTotalPayment > 0){
        this.isDisabledInvoice = false;
      }
      else if(this.MontoTotalPayment > parseFloat((this.invoiceHeader.invoiceTotal).toFixed(4))){
        this.isDisabledInvoice = true;
        this._utilsService.showNotification(2,"Total pagado es mayor al Total de la factura")
      }
      else{
        this.isDisabledInvoice = true;
      }
    }
    else{
      this.isMethodPay = false;
      this.isDisabledInvoice = false;
    }
  }

  /////////////////////FUNCTIONS SALES PERSONS/////////////////////////////////
  getSalesPList(code) {    
    return this._storeService.getSalesPerson(code,1).then(
      response => {
        if (response.result) {
          this.SalesPList = response.records;
          console.log('vendedores', this.SalesPList);
          // console.log("this.inventoryList ->" + code);
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  async onItemSelectSalesP(item: any) {
    console.log("---item---");
    console.log(item);
    const _selectedItemSalesP = await this.SalesPList.find(x => x.id == item.id);
    console.log(_selectedItemSalesP);

    this.SalesPerson = item.salesPersonCodeUser;
    console.log('SalesPerson -> ', this.SalesPerson);
  }

  getSelectSettingSalesP(selected) {
    // console.log(selected);
    Object.keys(selected).length > 0 ? this.selectedItemsSalesP = [selected] : '';

    this.dropdownSettingsSalesP = {
      singleSelection: true,
      searchPlaceholderText: 'Buscar...',
      closeDropDownOnSelection: true,
      allowSearchFilter: true,
      idField: 'salesPersonCodeUser',
      textField: 'salesPersonName'
    };

    // this.dropdownSettingsSalesP = {
    //   singleSelection: true,
    //   text: "Seleccione...",
    //   searchPlaceholderText: 'Buscar',
    //   noDataLabel: "Resultados...",
    //   enableCheckAll: false,
    //   enableSearchFilter: true,
    //   lazyLoading: true,
    //   idField: 'salesPersonCodeUser',
    //   textField: 'salesPersonName',
    //   searchBy: ['salesPersonCodeUser', 'salesPersonName']
    // };
  }

  ///////////////////////FUNCTION FOR TABLE///////////////////////
  entriesChange($event) {
    this.entries = $event.target.value;
  }

  filterTable($event) {
    let val = $event.target.value.toLowerCase();
    this.temp = this.inventoryList.filter(function (d) {
      for (var key in d) {
        if (d[key] !== null) {
          if (d[key].toString().toLowerCase().indexOf(val) !== -1) {
            return true;
          }
        }
      }
      return false;
    });
  }

  /////////////////////AGREGAR LINEA DESCRIPCION AL DETALLE FACTURA///////////////////////////
  saveLineInvoiceDesc() {
    this.invoiceDetail.invoiceDetailDiscount = 0;
    if (this.invoiceDetail.invoiceDetailDescription != "" && this.invoiceDetail.invoiceDetailQuantity > 0 && this.invoiceDetail.invoiceDetailUnitPrice > 0) {
      //Aumentar Codigo si no viene uno
      // if (this.itemCode == "I") {
      //   this.itemNumberCode++;
      //   this.itemCode += this.itemNumberCode;
      // }

      //Calcular subtotal de linea
      this.invoiceDetail.invoiceDetailSubtotal = this.invoiceDetail.invoiceDetailQuantity * this.invoiceDetail.invoiceDetailUnitPrice;

      if (this.invoiceDetail.invoiceDetailDiscount != undefined && this.invoiceDetail.invoiceDetailDiscount != null && this.invoiceDetail.invoiceDetailDiscount > 0) {        
        this.invoiceDetail.invoiceDetailSubtotal = parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.invoiceDetail.invoiceDetailUnitPrice).toFixed(4));
        this.invoiceDetail.invoiceDetailTax = 0;
      } else {
        this.invoiceDetail.invoiceDetailDiscount = 0;        
        this.invoiceDetail.invoiceDetailSubtotal = parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.invoiceDetail.invoiceDetailUnitPrice).toFixed(4));
        this.invoiceDetail.invoiceDetailTax = 0;
      }

      //Actualizar
      // this.invoiceLine.forEach((e) => {
      //   console.log('actualiza descripcion');
      //   if (e.itemCode == this.itemCode) {

      //     this.invoiceHeader.invoiceTotal -= e.total;

      //     e.itemCode = 0;
      //     e.measure = "UNI";
      //     e.taxCode = 1;
      //     e.taxName = "IVA";
      //     e.isService = this.invoiceDetail.invoiceDetailType;
      //     e.quantity = parseFloat(this.invoiceDetail.invoiceDetailQuantity.toFixed(6));
      //     e.description = this.invoiceDetail.invoiceDetailDescription;
      //     e.unitPrice = parseFloat((this.invoiceDetail.invoiceDetailUnitPrice).toFixed(6));
      //     e.price = parseFloat((this.invoiceDetail.invoiceDetailSubtotal + this.invoiceDetail.invoiceDetailDiscount).toFixed(6));
      //     e.discount = parseFloat((this.invoiceDetail.invoiceDetailDiscount).toFixed(6));
      //     e.taxAmount = parseFloat((this.invoiceDetail.invoiceDetailTax).toFixed(6));
      //     e.taxableAmount = parseFloat((this.invoiceDetail.invoiceDetailSubtotal - this.invoiceDetail.invoiceDetailTax).toFixed(6));
      //     e.total = parseFloat((this.invoiceDetail.invoiceDetailSubtotal).toFixed(6));

      //     // this.total = this.total + this.subTotal;
      //     this.addAmount = false;
      //   }
      // })

      let invoiceLineIdx = this.invoiceLine.length + 1;

      //Insertar
      if (this.addAmount == true) {
        console.log('Inserta descripcion');
        this.invoiceLine.push({
          subsidio: this.subsidioTemp,
          isOil: this.isOil,
          taxOilUP: this.idp,
          taxOilAmount: this.subIdp,
          taxOilName: this.petroleo,
          taxOilCode: this.taxOilCode,
          taxOilQuantity: this.invoiceDetail.invoiceDetailQuantity,          
          itemCode: 9999 + invoiceLineIdx,//this.itemCode,
          measure: "UNI",
          taxCode: 1,
          taxName: "IVA",
          isService: "B",
          quantity: parseFloat(this.invoiceDetail.invoiceDetailQuantity.toFixed(4)),
          description: this.invoiceDetail.invoiceDetailDescription,                    
          unitPrice: parseFloat(this.invoiceDetail.invoiceDetailUnitPrice.toFixed(4)),
          price: parseFloat((this.invoiceDetail.invoiceDetailSubtotal).toFixed(4)),
          taxAmount: parseFloat(this.invoiceDetail.invoiceDetailTax.toFixed(4)),
          taxableAmount: parseFloat((this.invoiceDetail.invoiceDetailSubtotal + this.invoiceDetail.invoiceDetailTax).toFixed(4)),
          discount: parseFloat(this.invoiceDetail.invoiceDetailDiscount.toFixed(4)),

          total: parseFloat(this.invoiceDetail.invoiceDetailSubtotal.toFixed(4))
        });
      }
      console.log('Linea',this.invoiceLine);
      // Sumar Total      
      this.invoiceHeader.invoiceIDP += parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.idp).toFixed(4));
      this.invoiceHeader.invoiceTotal += parseFloat((this.invoiceDetail.invoiceDetailSubtotal + (parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.idp).toFixed(4)))).toFixed(4));
      this.invoiceHeader.invoiceTax += parseFloat(this.invoiceDetail.invoiceDetailTax.toFixed(6));
      this.cleanLineInvoice();
    }

    this.ValidarCF();
    this.Pagado();

    this.isDisabled = false;
  }

  // CALCULAR IMPUESTO DE LINEA
  calculateTax() {
    let subTotalLine;

    subTotalLine = (this.invoiceDetail.invoiceDetailQuantity * this.invoiceDetail.invoiceDetailUnitPrice);

    if (this.invoiceDetail.invoiceDetailDiscount > 0) {
      if (this.invoiceDetail.invoiceDetailDiscount <= subTotalLine) {
        subTotalLine = subTotalLine - this.invoiceDetail.invoiceDetailDiscount;
      } else {
        this._utilsService.showNotification(2, "Cantidad No permitida");
        this.invoiceDetail.invoiceDetailDiscount = 0;
      }
    }

    let tax;
    tax = (subTotalLine - (subTotalLine * this.taxToPay)).toFixed(6);
    this.invoiceDetail.invoiceDetailTax = parseFloat(tax);
  }

  public SKUx: string;
  async CargarSKU() {
    console.log('----Cargar inventory---', this.inventoryList);
    var sku;
    sku = this.SKUx;
    //alert(sku);

    const SKUs = this.inventoryList.find(({ inventoryBusinessCode }) => inventoryBusinessCode === sku);
    console.log('SKU Buscado', SKUs);
    //console.log('SKU Buscado STOCK', SKUs.stock);

    if(SKUs == undefined){
      this._utilsService.showNotification(2, 'Producto no disponible, validar stock en inventario');
    }
    else{

      if(sku.length > 3){
        //const _selectedItem = await this.inventoryList.find(x => x.id == sku);
        const _selectedItem = SKUs
        console.log('----_selectedItem---', _selectedItem);
  
        //SI ES PETROLIO
        this.idp = 0;
        this.subIdp = 0;
        this.subsidioTemp = 0;
        this.isOil = null;
        this.petroleo = null;
        if (_selectedItem.inventoryProduct == 3) {
          this.isOil = 1
          this.idp = 4.7;
          this.taxOilCode = 1;
          this.petroleo = "PETROLEO";
        } else if (_selectedItem.inventoryProduct == 4) {
          this.idp = 4.6;
          this.subsidioTemp = 2.5;
          this.taxOilCode = 2;
          this.petroleo = "PETROLEO";
        } else if (_selectedItem.inventoryProduct == 5) {
          this.idp = 1.3;
          this.subsidioTemp = 5;
          this.taxOilCode = 4;
          this.petroleo = "PETROLEO";
        }
  
        this.itemCode = _selectedItem.inventoryCode;
        this.invoiceDetail.invoiceDetailDescription = _selectedItem.itemName;
        this.invoiceDetail.invoiceDetailType = 'B';
        this.stock = _selectedItem.inventoryQuantity;
        this.Minstock = _selectedItem.inventoryMin;
  
        if (_selectedItem.inventorySerialFlag == 1) {
          this.loading = true;
          this.serialSelectedTemp = [];
          this.serialList = [];
          const response = await this._inventoryService.getItemSerial(this.itemCode);
          this.serialList = response.records[1];
  
          this.serial = true;
          this.loading = false;
        } else {
          this.serial = false
        }
  
        await this.saveLineInvoice();
        this.SKUx = "";      
      }

    }    
    
  }

  public jumpSerial: boolean;
  async cargarTrasnferencia(code) {
    this.loading = true;
    this.isDisabled = true;
    this.disabled = true;

    await this._warehouseService.getOneTransfer(code).then(
      response => {
        this.transferCode = response.records[0].transferCode;
        this.transferDetail = response.records[0].detail;
      });

    for (const e of this.transferDetail) {
      const _selectedItem = await this.inventoryList.find(x => x.id == parseFloat(e.transferInventoryDetailInventoryCode));
      this.invoiceDetail.invoiceDetailType = 'B';
      this.itemCode = e.transferInventoryDetailInventoryCode;
      this.invoiceDetail.invoiceDetailQuantity = parseFloat(e.transferInventoryDetailQuantity);
      this.invoiceDetail.invoiceDetailDescription = _selectedItem.inventoryBusinessCode + ' - ' + e.transferInventoryDetailDescription;
      this.stock = _selectedItem.inventoryQuantity;
      this.priceType = 1;

      // Nuevo
      if (parseFloat(e.transferDetailType) === 1) {
        await this.saveLineInvoice();
      } else {
        let series = await this._warehouseService.getOneSerial(this.transferCode, e.transferInventoryDetailInventoryCode);
        for (const i of series.records[0].detail) {
          await this.serialSelected.push({
            serialCode: parseFloat(i.trasferSerialDetailSerialCode),
            inventorySerialSerial: i.trasferSerialDetailDescription
          });
          await this.serialSelectedTemp.push({
            serialCode: parseFloat(i.trasferSerialDetailSerialCode),
            inventorySerialSerial: i.trasferSerialDetailDescription
          });
        }
        this.jumpSerial = true;
        await this.saveLineInvoiceSerial();
        this.serialSelectedTemp = [];
      }
      this.jumpSerial = true;
    };

    this.loading = false;
    this.isDisabled = false;
    this.disabled = false;
  }

  onChangepaymentType(event) {
    this.invoiceHeader.paymentType = event;
    this.tipoPago = event;
    // console.log(this.tipoPago);
  }

  ///////////////////////COMPANY///////////////////////
  getCompany(company) {
    return this._companyService.getOne(company).then(
      response => {
        if (response.result) {
          this.company = response.records[0];
          this.company.companyTaxToPay == 10 ? this.taxToPay = 0.10 : this.taxToPay = 0.10;
          this.company.companyTaxToPay == 10 ? this.regimenMessage = "Sujeto a pagos trimestrales ISR" : this.regimenMessage = "*No genera derecho a crédito fiscal";
          this.company.companyLogo != 'undefined' ? this.companyLogoUrl = this.company.companyLogoUrl : '';
          this.companyAddDescription = this.company.companyAddDescription;
          this.companyInventoryView = this.company.companyInventoryStores;
          this.companyExentaInvoice = this.company.companyExentaInvoice;
          this.companyTaxCode = this.company.companyTaxDocument;
          this.companySendStock = this.company.companySendEmailStock;
          this.companyAddressNotif = this.company.companyEmailAddress;
          console.log('Company -> ', this.company);
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  ///////////////////////STORE///////////////////////
  getStore(store) {
    return this._storeService.getOne(store).then(
      response => {
        if (response.result) {
          this.store = response.records[0];
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  ///////////////////////SELECT///////////////////////
  getSelectSetting(selected) {
    // console.log(selected);
    Object.keys(selected).length > 0 ? this.selectedItems = [selected] : '';

    this.dropdownSettings = {
      singleSelection: true,
      searchPlaceholderText: 'Buscar...',
      closeDropDownOnSelection: true,
      allowSearchFilter: true,
      idField: 'id',
      textField: 'itemName'
    };

    // this.dropdownSettingsProduct = {
    //   singleSelection: true,
    //   text: "Seleccione...",
    //   searchPlaceholderText: 'Buscar',
    //   noDataLabel: "Resultados...",
    //   enableCheckAll: false,
    //   enableSearchFilter: true,
    //   lazyLoading: true,
    //   idField: 'id',
    //   textField: 'itemName',
    //   searchBy: ['id', 'itemName']
    // };
  }

  getSelectSettingSerial(selected) {
    Object.keys(selected).length > 0 ? this.selectedItemsSerial = [selected] : '';

    this.dropdownSettingsSerial = {
      idField: 'InventorySerialCode',
      textField: 'inventorySerialSerial',
      itemsShowLimit: 3,
      enableCheckAll: false,
      singleSelection: true,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar",
    }
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  toggleCloseDropdownSelection() {
    this.closeDropdownSelection = !this.closeDropdownSelection;
    this.dropdownSettings = Object.assign({}, this.dropdownSettings, { closeDropDownOnSelection: this.closeDropdownSelection });
  }

  getInventoryList(code) {
    this.inventoryList = [];
    return this._inventoryService.getAllByStore(code).then(
      response => {
        if (response.result) {
          this.inventoryList = response.records;
          this.temp = this.inventoryList;
          // console.log("this.inventoryList ->" + code);
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  serial = false;
  async onItemSelect(item: any) {
    console.log("---item---");
    console.log(item);
    const _selectedItem = await this.inventoryList.find(x => x.id == item.id);

    //SI ES PETROLIO
    this.idp = 0;
    this.subIdp = 0;
    this.subsidioTemp = 0;
    this.isOil = null;
    this.petroleo = null;
    if (_selectedItem.inventoryProduct == 3) {
      this.isOil = 1
      this.idp = 4.7;
      this.taxOilCode = 1;
      this.petroleo = "PETROLEO";
    } else if (_selectedItem.inventoryProduct == 4) {
      this.idp = 4.6;
      this.subsidioTemp = 2.5;
      this.taxOilCode = 2;
      this.petroleo = "PETROLEO";
    } else if (_selectedItem.inventoryProduct == 5) {
      this.idp = 1.3;
      this.subsidioTemp = 5;
      this.taxOilCode = 4;
      this.petroleo = "PETROLEO";
    }

    this.itemCode = item.id;
    this.invoiceDetail.invoiceDetailDescription = item.itemName;
    this.invoiceDetail.invoiceDetailUnitPrice = _selectedItem.inventoryPrice;
    this.invoiceDetail.invoiceDetailType = 'B';
    this.stock = _selectedItem.inventoryQuantity;
    this.Minstock = _selectedItem.inventoryMin;

    if (_selectedItem.inventorySerialFlag == 1) {
      this.loading = true;
      this.serialSelectedTemp = [];
      this.serialList = [];
      const response = await this._inventoryService.getItemSerial(this.itemCode);
      this.serialList = response.records[1];
      console.log('serialList',this.serialList);

      this.serial = true;
      this.loading = false;
    } else {
      this.serial = false
    }
  }

  async onItemSelectSerial(item: any) {
    // console.log('itemSerial', item);

    let res_find = await this.serialList.find(x => x.InventorySerialCode === item.InventorySerialCode);
    // console.log('res_find', res_find);
    // console.log('inventorySerialStock', res_find.inventorySerialStock);
    
    // this.serialSelected.pop();
    this.serialSelectedTemp.pop();

    // this.serialSelected.push({
    //   serialCode: item.InventorySerialCode,
    //   inventorySerialSerial: item.inventorySerialSerial,
    //   inventorySerialStock: res_find.inventorySerialStock
    // });

    this.serialSelectedTemp.push({
      serialCode: item.InventorySerialCode,
      inventorySerialSerial: item.inventorySerialSerial,
      inventorySerialStock: res_find.inventorySerialStock
    });

    console.log('serialSelectedTemp', this.serialSelectedTemp);

  }

  async onItemDeSelectSerial(item: any) {    
    // this.serialSelected.forEach((e, index) => {
    //   if (e.serialCode == item.InventorySerialCode)
    //     this.serialSelected.splice(index, 1);
    // });

    this.serialSelectedTemp.forEach((i, indece) => {
      if (i.serialCode == item.InventorySerialCode)
        this.serialSelectedTemp.splice(indece, 1);
    });
  }

  ///////////////////////FUNCTION CHANGE COIN///////////////////////
  onChange(event) {
    this.invoiceHeader.invoiceCoin = event;

    if (this.invoiceHeader.invoiceCoin == 0) {
      this.moneda = "₲";
      this.invoiceHeader.invoiceCurrency = 'PAB';
      this.invoiceHeader.invoiceExchangeRate = 0;
    } else if (this.invoiceHeader.invoiceCoin == 1) {
      this.moneda = "$"
      this.invoiceHeader.invoiceCurrency = 'USD';
    }
  }

  ///////////////////////FUNCTION CHANGE PRICE///////////////////////
  onChangePrice(event) {
    this.priceType = parseFloat(event);
  }

  ///////////////////////FUNCTION VALIDATE DATE///////////////////////
  validateDate($event) {
    $event.preventDefault();
    var valid = false;
    var now = this.nowDay.split('-');
    var date = this.invoiceHeader.invoiceDate.split('-');

    if (date[0] == now[0] || parseFloat(date[0]) == parseFloat(now[0]) - 1) {
      if (date[1] == now[1]) {
        if (parseFloat(date[2]) <= parseFloat(now[2]) + 5 && parseFloat(date[2]) >= parseFloat(now[2]) - 5) {
          valid = true;
        }
      }
      else if (parseFloat(date[1]) == parseFloat(now[1]) - 1 || parseFloat(date[1]) == 12) {
        if (parseFloat(date[2]) >= 26) {
          valid = true;
        }
      }
    }

    if (valid == false) {
      this._utilsService.showNotification(2, 'Fecha fuera de rango')
      this.invoiceHeader.invoiceDate = this.nowDay;
    };
  }

  ///////////////////////FUNCTION CHANGE INTERAL SERIAL///////////////////////
  onChangeInternSerial(event) {
    this.invoiceHeader.invoiceInternSerial = event;
  }

  // GUARDAR UNA LINEA DE COMPRA
  async saveLineInvoice() {
    this.isDisabled = true;
    this.disabled = true;
    
    if(true){ //Resto de empresas que no manejan decimales

      if (this.invoiceDetail.invoiceDetailQuantity > 0) {

        //Actualizar?
        let update = false;
        console.log("---invoiceLine---");
        console.log(this.invoiceLine);
        console.log("---invoiceDetail---");
        console.log(this.invoiceDetail);
        console.log("---itemCode---");
        console.log(this.itemCode);
        for await (const e of this.invoiceLine) {
          if (e.itemCode == this.itemCode) {
            //Validacion
            let quantity;
            this.isEdit === true ? quantity = this.invoiceDetail.invoiceDetailQuantity : quantity = e.quantity + this.invoiceDetail.invoiceDetailQuantity;
  
            const response = await this._inventoryService.getPriceByItem(this.itemCode, quantity);
            switch (this.priceType) {
              case 1: this.invoiceDetail.invoiceDetailUnitPrice = response.records.precio;
                break;
              case 2: this.invoiceDetail.invoiceDetailUnitPrice = response.records.inventoryPriceDiscount;
                break;
              case 3: this.invoiceDetail.invoiceDetailUnitPrice = response.records.inventorySalePrice;
                break;
              case 4: this.invoiceDetail.invoiceDetailUnitPrice = response.records.inventoryminprice;
                break;
            }
  
            if (this.company.companyExistenceFlag === 1 || quantity <= this.stock) {
              //Restar Encabezado
              this.subsidio -= e.subsidio;            
              this.invoiceHeader.invoiceIDP -= parseFloat((e.taxOilAmount).toFixed(4));
              this.invoiceHeader.invoiceTotal -= parseFloat((e.total).toFixed(4));
              this.invoiceHeader.invoiceTax -= parseFloat((e.taxAmount).toFixed(4));
  
              //Realizar Calculos
              if (parseFloat(e.discount) > 0) {
                this.invoiceDetail.invoiceDetailSubtotal = parseFloat((quantity * this.invoiceDetail.invoiceDetailUnitPrice).toFixed(4));
                this.invoiceDetail.invoiceDetailSubtotal = parseFloat((this.invoiceDetail.invoiceDetailSubtotal - e.discount).toFixed(4));
                this.invoiceDetail.invoiceDetailTax = 0;
              } else {
                this.invoiceDetail.invoiceDetailDiscount = e.discount;
                this.invoiceDetail.invoiceDetailSubtotal = quantity * this.invoiceDetail.invoiceDetailUnitPrice;
                this.invoiceDetail.invoiceDetailTax = 0;
              }
  
              //Editar Linea
              e.quantity = quantity;
              e.unitPrice = this.invoiceDetail.invoiceDetailUnitPrice;
              e.price = parseFloat((this.invoiceDetail.invoiceDetailSubtotal).toFixed(4));
              e.taxAmount = parseFloat((this.invoiceDetail.invoiceDetailTax).toFixed(4));
              e.taxableAmount = parseFloat((this.invoiceDetail.invoiceDetailSubtotal + this.invoiceDetail.invoiceDetailTax).toFixed(4));
              e.taxOilAmount = parseFloat((quantity * this.idp).toFixed(4)),
              e.total = parseFloat((this.invoiceDetail.invoiceDetailSubtotal + (parseFloat((quantity * this.idp).toFixed(4)))).toFixed(4)),
              e.taxOilQuantity = quantity;
              e.subsidio = (quantity * this.subsidioTemp);
  
              //Sumar Encabezado 
              this.subsidio += e.subsidio;
              this.invoiceHeader.invoiceIDP += parseFloat((quantity * this.idp).toFixed(4));
              this.invoiceHeader.invoiceTotal += parseFloat((this.invoiceDetail.invoiceDetailSubtotal + (quantity * this.idp)).toFixed(4));
              this.invoiceHeader.invoiceTax += parseFloat(this.invoiceDetail.invoiceDetailTax.toFixed(4));
              this.selectedItems = [];
              this.cleanLineInvoice();
            } else {
              this._utilsService.showNotification(2, 'Cantidad Excede Exitencia');
            }
            update = true;
            this.isEdit = false;
            this.addAmount = false;
            this.isDisabled = false;
            this.disabled = false;
          }
        };
  
        //Nuevo Item
        if (this.addAmount === true && update === false) {
          const response = await this._inventoryService.getPriceByItem(this.itemCode, this.invoiceDetail.invoiceDetailQuantity);
          switch (this.priceType) {
            case 1: this.invoiceDetail.invoiceDetailUnitPrice = response.records.precio;
              break;
            case 2: this.invoiceDetail.invoiceDetailUnitPrice = response.records.inventoryPriceDiscount;
              break;
            case 3: this.invoiceDetail.invoiceDetailUnitPrice = response.records.inventorySalePrice;
              break;
            case 4: this.invoiceDetail.invoiceDetailUnitPrice = response.records.inventoryminprice;
              break;
          }
  
          this.subIdp = parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.idp).toFixed(4));
          this.invoiceDetail.invoiceDetailSubtotal = parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.invoiceDetail.invoiceDetailUnitPrice).toFixed(4));
          // this.invoiceDetail.invoiceDetailTax = parseFloat(((this.invoiceDetail.invoiceDetailSubtotal * this.taxToPay)).toFixed(4));
          this.invoiceDetail.invoiceDetailTax = 0;
  
          console.log('linea subtotal ', this.invoiceDetail.invoiceDetailSubtotal);
          console.log('linea unit ', this.invoiceDetail.invoiceDetailUnitPrice);
          //Validacion
          if (this.company.companyExistenceFlag === 1 || this.invoiceDetail.invoiceDetailQuantity <= this.stock) {
  
            let DifInventario = this.stock - this.invoiceDetail.invoiceDetailQuantity;

            console.log('STOCK MINIMO', DifInventario, this.stock, this.invoiceDetail.invoiceDetailQuantity);
            console.log('STOCK MINIMO 2',this.Minstock);
            console.log('STOCK MINIMO 3',this.company.companyExistenceFlag);

            if(this.company.companyExistenceFlag === 0 && DifInventario <= this.Minstock){
              this._utilsService.showNotification(2, 'El STOCK MINIMO ha llegado a su limite configurado.');              
              //enviar correo
              this.invoiceLineMinStock.push({
                itemCode: this.itemCode,
                description: this.invoiceDetail.invoiceDetailDescription,
                Minstock: this.Minstock
              });

              console.log('MinStock', this.invoiceLineMinStock);
            }

            //Guardar Linea
            await this.invoiceLine.push({
              //Area de combustible
              subsidio: this.subsidioTemp,
              isOil: this.isOil,
              taxOilUP: this.idp,
              taxOilAmount: this.subIdp,
              taxOilName: this.petroleo,
              taxOilCode: this.taxOilCode,
              taxOilQuantity: this.invoiceDetail.invoiceDetailQuantity,
              itemCode: this.itemCode,
              measure: "UNI",
              taxCode: 1,
              taxName: "IVA",
              isService: this.invoiceDetail.invoiceDetailType,
              quantity: this.invoiceDetail.invoiceDetailQuantity,
              description: this.invoiceDetail.invoiceDetailDescription,
              discount: 0,
              unitPrice: parseFloat(this.invoiceDetail.invoiceDetailUnitPrice.toFixed(4)),
              price: parseFloat((this.invoiceDetail.invoiceDetailSubtotal).toFixed(4)),
              taxAmount: parseFloat(this.invoiceDetail.invoiceDetailTax.toFixed(4)),
              taxableAmount: parseFloat((this.invoiceDetail.invoiceDetailSubtotal + this.invoiceDetail.invoiceDetailTax).toFixed(4)),
              total: parseFloat(((this.invoiceDetail.invoiceDetailSubtotal + (this.invoiceDetail.invoiceDetailQuantity * this.idp))).toFixed(4)),
            });
            this.subsidio += (this.invoiceDetail.invoiceDetailQuantity * this.subsidioTemp);
            this.invoiceHeader.invoiceIDP += parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.idp).toFixed(4));
            this.invoiceHeader.invoiceTotal += parseFloat((this.invoiceDetail.invoiceDetailSubtotal + (parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.idp).toFixed(4)))).toFixed(4));
            this.invoiceHeader.invoiceTax += parseFloat(this.invoiceDetail.invoiceDetailTax.toFixed(6));
            this.selectedItems = [];
            this.cleanLineInvoice();
          } 
          else {
            this._utilsService.showNotification(2, 'Cantidad Excede Exitencia');
          }
          this.isDisabled = false;
          this.disabled = false;
        }
      } else {
        this._utilsService.showNotification(2, "Ingresa una cantidad")
      }
      this.addAmount = true;
      this.isDisabled = false;
      this.disabled = false;
      this.ValidarCF();
      this.Pagado();

    }

    
  }

  // GUARDAR LINEA CON SERIES
  async saveLineInvoiceSerial() {
    this.isDisabled = true;
    this.disabled = true;    

    // let res_find = await this.invoiceLine.find(x => x.itemCode === this.itemCode);

    // if (!res_find) {
      // if (this.invoiceDetail.invoiceDetailQuantity == this.serialSelectedTemp.length) { //Valida cantidad venta contra cantidad de series seleccionada
      console.log('serialSelectedTemp', this.serialSelectedTemp);
      if (this.serialSelectedTemp[0].inventorySerialStock >= this.invoiceDetail.invoiceDetailQuantity) { //Valida cantidad venta contra Stock de serie seleccionada

        if (!this.jumpSerial) {
          if(this.companyTaxCode == "107832135"){
            this.invoiceDetail.invoiceDetailDescription += ' \n';
            for await (const e of this.serialSelectedTemp) {
              this.invoiceDetail.invoiceDetailDescription += e.inventorySerialSerial + ', \n';
            }
          }else{
            this.invoiceDetail.invoiceDetailDescription += ' SERIES: ';
            for await (const e of this.serialSelectedTemp) {
              this.invoiceDetail.invoiceDetailDescription += e.inventorySerialSerial + ', ';
            }
          }          
        }

        // const response = await this._inventoryService.getPriceByItem(this.itemCode, this.invoiceDetail.invoiceDetailQuantity);
        // switch (this.priceType) {
        //   case 1: this.invoiceDetail.invoiceDetailUnitPrice = response.records.precio;
        //     break;
        //   case 2: this.invoiceDetail.invoiceDetailUnitPrice = response.records.inventoryPriceDiscount;
        //     break;
        //   case 3: this.invoiceDetail.invoiceDetailUnitPrice = response.records.inventorySalePrice;
        //     break;
        //   case 4: this.invoiceDetail.invoiceDetailUnitPrice = response.records.inventoryminprice;
        //     break;
        // }

        this.subIdp = 0;
        this.invoiceDetail.invoiceDetailSubtotal = parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.invoiceDetail.invoiceDetailUnitPrice).toFixed(4));
        this.invoiceDetail.invoiceDetailTax = parseFloat((this.invoiceDetail.invoiceDetailSubtotal - (this.invoiceDetail.invoiceDetailSubtotal / this.taxToPay)).toFixed(4));

        await this.invoiceLine.push({
          //Area de Serie
          serial: this.serialSelectedTemp,
          //Area de combustible
          isOil: this.isOil,
          taxOilUP: this.idp,
          taxOilAmount: this.subIdp,
          taxOilName: this.petroleo,
          taxOilCode: this.taxOilCode,
          taxOilQuantity: this.invoiceDetail.invoiceDetailQuantity,
          itemCode: this.itemCode,
          measure: "UNI",
          taxCode: 1,
          taxName: "IVA",
          isService: this.invoiceDetail.invoiceDetailType,
          quantity: this.invoiceDetail.invoiceDetailQuantity,
          description: this.invoiceDetail.invoiceDetailDescription,
          discount: 0,
          unitPrice: parseFloat(this.invoiceDetail.invoiceDetailUnitPrice.toFixed(4)),
          price: parseFloat((this.invoiceDetail.invoiceDetailSubtotal).toFixed(4)),
          taxAmount: parseFloat(this.invoiceDetail.invoiceDetailTax.toFixed(4)),
          taxableAmount: parseFloat((this.invoiceDetail.invoiceDetailSubtotal - this.invoiceDetail.invoiceDetailTax).toFixed(4)),
          total: parseFloat((this.invoiceDetail.invoiceDetailSubtotal + (this.invoiceDetail.invoiceDetailQuantity * this.idp)).toFixed(4)),
        });
        this.invoiceHeader.invoiceIDP += parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.idp).toFixed(4));
        this.invoiceHeader.invoiceTotal += parseFloat((this.invoiceDetail.invoiceDetailSubtotal + (parseFloat((this.invoiceDetail.invoiceDetailQuantity * this.idp).toFixed(4)))).toFixed(4));
        this.invoiceHeader.invoiceTax += parseFloat(this.invoiceDetail.invoiceDetailTax.toFixed(4));

        this.serialSelected.push({
            serialCode: this.serialSelectedTemp[0].serialCode,
            inventorySerialSerial: this.serialSelectedTemp[0].inventorySerialSerial,
            inventorySerialStock: this.serialSelectedTemp[0].inventorySerialStock,
            inventoryQuantity: this.invoiceDetail.invoiceDetailQuantity,
            itemCode: this.itemCode
          });

        this.cleanLineInvoice();

      } else {
        this._utilsService.showNotification(2, 'El stock de la serie seleccionada no es suficiente para lo solicitado');
      }
    // } else {
    //   this._utilsService.showNotification(3, 'Item ya ingresado, por favor eliminalo antes.');
    // }
    console.log('Lineas', this.invoiceLine);
    console.log('serialSelectedTemp', this.serialSelectedTemp);
    console.log('serialSelected', this.serialSelected);
    this.isDisabled = false;
    this.disabled = false;
  }

  // APLICAR DESCUENTO EN TIEMPO REAL
  ApplyDiscount($event, item, descuento) {
    $event.preventDefault();

    if(this.company.companyCode == 24){ //Manejo de decimales ETISA
      
      this.invoiceLine.forEach((e) => {
        if (e.itemCode == item) {
          let temporal = parseFloat(e.quantity) * parseFloat(e.unitPrice);
  
          if (parseFloat(descuento) <= temporal) {
            this.invoiceHeader.invoiceTotal = parseFloat((this.invoiceHeader.invoiceTotal - parseFloat(e.total)).toFixed(6));
            this.invoiceHeader.invoiceTax = parseFloat((this.invoiceHeader.invoiceTax - parseFloat(e.taxAmount)).toFixed(6));
            e.total = parseFloat((temporal - parseFloat(descuento)).toFixed(6));
            e.taxAmount = parseFloat((parseFloat(e.total) - (parseFloat(e.total) / this.taxToPay)).toFixed(6));
            e.taxableAmount = parseFloat((parseFloat(e.total) - parseFloat(e.taxAmount)).toFixed(6));
            this.invoiceHeader.invoiceTotal = parseFloat((this.invoiceHeader.invoiceTotal + parseFloat(e.total)).toFixed(6));
            this.invoiceHeader.invoiceTax = parseFloat((this.invoiceHeader.invoiceTax + parseFloat(e.taxAmount)).toFixed(6));
          } else {
            this._utilsService.showNotification(2, "Cantidad No permitida");
          }
        }
      });
      
    }
    else{
      this.invoiceLine.forEach((e) => {
        if (e.itemCode == item) {
          console.log('encontrado', e);
          let temporal = parseFloat(e.quantity) * parseFloat(e.unitPrice);

          let DifInventario = this.stock - e.quantity;

          if(this.company.companyExistenceFlag === 0 && DifInventario <= this.Minstock){
            this._utilsService.showNotification(2, 'El STOCK MINIMO ha llegado a su limite configurado.');
            //enviar correo
            this.invoiceLineMinStock.push({
              itemCode: this.itemCode,
              description: this.invoiceDetail.invoiceDetailDescription,
              Minstock: this.Minstock
            });

            console.log('MinStock', this.invoiceLineMinStock);
          }
  
          if (parseFloat(descuento) <= temporal) {
            this.invoiceHeader.invoiceTotal = parseFloat((this.invoiceHeader.invoiceTotal - parseFloat(e.total)).toFixed(4));
            this.invoiceHeader.invoiceTax = parseFloat((this.invoiceHeader.invoiceTax - parseFloat(e.taxAmount)).toFixed(4));
            e.total = parseFloat((temporal - parseFloat(descuento)).toFixed(4));
            e.taxAmount = parseFloat((parseFloat(e.total) - (parseFloat(e.total) / this.taxToPay)).toFixed(4));
            e.taxableAmount = parseFloat((parseFloat(e.total) - parseFloat(e.taxAmount)).toFixed(4));
            e.price = parseFloat((e.quantity * e.unitPrice).toFixed(4));
            this.invoiceHeader.invoiceTotal = parseFloat((this.invoiceHeader.invoiceTotal + parseFloat(e.total)).toFixed(4));
            this.invoiceHeader.invoiceTax = parseFloat((this.invoiceHeader.invoiceTax + parseFloat(e.taxAmount)).toFixed(4));
          } else {
            this._utilsService.showNotification(2, "Cantidad No permitida");
          }
        }
      });
    }

    console.log('Lineas', this.invoiceLine);

    this.ValidarCF();
  }

  ApplyQuantity($event, item, cantidad){
    $event.preventDefault();

    this.invoiceLine.forEach((e) => {
      if (e.itemCode == item) {
        let temporal = parseFloat(e.quantity) * parseFloat(e.unitPrice);

        if (cantidad > 0) {
          this.invoiceHeader.invoiceTotal = parseFloat((this.invoiceHeader.invoiceTotal - parseFloat(e.total)).toFixed(4));
          this.invoiceHeader.invoiceTax = parseFloat((this.invoiceHeader.invoiceTax - parseFloat(e.taxAmount)).toFixed(4));
          e.total = parseFloat((temporal).toFixed(4));
          e.taxAmount = parseFloat((parseFloat(e.total) - (parseFloat(e.total) / this.taxToPay)).toFixed(4));
          e.taxableAmount = parseFloat((parseFloat(e.total) - parseFloat(e.taxAmount)).toFixed(4));
          this.invoiceHeader.invoiceTotal = parseFloat((this.invoiceHeader.invoiceTotal + parseFloat(e.total)).toFixed(4));
          this.invoiceHeader.invoiceTax = parseFloat((this.invoiceHeader.invoiceTax + parseFloat(e.taxAmount)).toFixed(4));
        } else {
          this._utilsService.showNotification(2, "Cantidad No permitida");
        }
      }
    });

    this.ValidarCF();    
  }

  // ELIMINAR UNA LINEA
  async deleteLine(item) {
    this.isDisabled = true;
    this.disabled = true;

    await this.invoiceLine.forEach(async (e, index) => {
      if (e.itemCode === item) {

        if (e.taxOilName != undefined) {          
          this.subsidio -= parseFloat(e.subsidio);
          this.invoiceHeader.invoiceIDP = this.invoiceHeader.invoiceIDP - parseFloat(e.taxOilAmount);
        }

        if (e.serial) {
          for (const i of e.serial) {
            let indice = this.serialSelected.findIndex(x => x.serialCode === i.serialCode);
            this.serialSelected.splice(indice, 1);
          };
        }

        this.invoiceHeader.invoiceTotal = parseFloat((this.invoiceHeader.invoiceTotal - parseFloat(e.price)).toFixed(4));
        this.invoiceHeader.invoiceTax = parseFloat((this.invoiceHeader.invoiceTax - parseFloat(e.taxAmount)).toFixed(4));
        this.invoiceLine.splice(index, 1);
      }
    })
    this.cleanLineInvoice();
    this.isDisabled = false;
    this.disabled = false;
  }

  // LIMPIAR LINEA PARA NUEVO INGRESO
  cleanLineInvoice() {
    this.jumpSerial = false;
    this.isDisabled = false;
    this.disabled = false;
    this.addAmount = true;
    this.priceType = 1;
    this.isEdit = false;
    this.serial = false;
    this.selectedItemsSerial = null;
    this.selectedItems = [];
    this.invoiceDetail = {} as InvoiceDetail;
    this.invoiceDetail.invoiceDetailQuantity = 1;
  }

  onChangeTypeClient(event) {    
    this.client.clientType = event;
    this.tipoCliente = event;
    console.log('----->', this.tipoCliente);

    if(event == 2){
      this.disabledEXT = false;
      this.client.clientName = "";
      this.client.clientTaxDocument = "";
    }
    else{
      this.disabledEXT = true;
      this.client.clientName = "";
      this.client.clientTaxDocument = "";
    }
  }

  onChangeTypeRuc(event) {        
    this.client.clientTR = event;
    console.log('----->', this.client.clientTR);    
  }

  buscarNITNew($event, nit){

    let jsonNit = {
      "transmitter": {
        "transmitterPrefix": "6801331", // this.company.companyPrefix,
        "transmitterUser": "6801331", //this.company.companyPrefix,
        "transmitterKey": "U9adphD60NSAed4s052yY7P"//this.company.companyKey        
      },
      "client": {
        "clientTaxDocument": "70514089"
      }
    }

    let clienteSAT = this._clientService.searchNitSATNew('70514089','0').then(
      async response => {
        console.log('Cliente New', response);
        // if (response.tipo_respuesta == 0) {
        //   //this.client.clientName = response.nombre[0];
        //   //console.log(response.nombre[0]);
        //   this.client.clientName =  response.nombre[0];
        //   this.client.clientStatus = 1;
        //   this.client.clientDeleted = 0;
        //   this.client.clientPhone = "00000000";
        //   this.client.clientEmail = "info@clever.com";
        //   this.client.clientAddress = "CIUDAD";

        //   this.insertNewClient = true;
        //   this.recurrentClient = false;
        //   this.viewBilling();
        //   this._utilsService.showNotification(4, "Cliente Nuevo");
        // } else {
        //   this._utilsService.showNotification(3, response.listado_errores[0].error[0].desc_error[0]);
        // }
      },
      error => {
        console.log(error);
      }
    );

  }

  ///////////////////////Funcion de Buscar por NIT///////////////////////
  buscarNITLocal($event, nit) {
    console.log('buscarNITLocal', nit);
    $event.preventDefault();
    this.isDisabled = true;
    this.disabled = true;
    this.loading = true;
    // console.log(this.client.clientType);

    if(this.client.clientType == 2){

      this.client.clientName = this.client.clientName;
      this.client.clientStatus = 1;
      this.client.clientDeleted = 0;
      this.client.clientPhone = "00000000";
      this.client.clientEmail = "info@clever.com";
      this.client.clientAddress = "CIUDAD";
      this.client.clientDV = "0";
      this.client.clientTR = "0";
      this.client.clientDOperacion = "PY";
      // this.client.clientTaxDocument = "CF";

      this.insertNewClient = true;
      this.recurrentClient = false;
      this.viewBilling();
      this._utilsService.showNotification(4, "SE EMITIRA FACTURA COMO EXTRANJERO");
      this.loading = false;
      this.client.clientType = 2;
      this.tipoCliente = 2;

      this.isDisabled =false;

    }
    else{
      if(nit == "CF"){
        this.client.clientType = 0;
        this.tipoCliente = 0;

        this.client.clientName =  "CONSUMIDOR FINAL";
        this.client.clientStatus = 1;
        this.client.clientDeleted = 0;
        this.client.clientPhone = "00000000";
        this.client.clientEmail = "info@clever.com";
        this.client.clientAddress = "CIUDAD";
        this.client.clientDV = "0";
        this.client.clientTR = "0";
        this.client.clientDOperacion = "PY";
        this.client.clientTaxDocument = "CF";

        this.insertNewClient = true;
        this.recurrentClient = false;
        this.viewBilling();

        this.loading = false;
        this.isDisabled = false;

      }
      else{

        return this._clientService.getOneByCompanyNit(this.companyCode, nit).then(
          response => {

            console.log('response searchClient', response);
            // console.log(response.records)
  
            if (response.records.length > 0) {
              this.client = response.records[0];
              // this.client.clientDV = 0;
              // this.client.clientTR = 0;
              this.client.clientDOperacion = "PY";
              this.client.clientPhone = "00000000";
              this.recurrentClient = true;
              this.insertNewClient = false;
              this.viewBilling();
              this._utilsService.showNotification(1, response.message);
            }
            else {

              let dataClient = {
                transmitter: {
                  transmitterPrefix: this.company.companyPrefix,
                  transmitterToken: this.company.companyToken,
                  transmitterTaxDocument: this.company.companyTaxDocument
                },
                client: {
                  ruc: nit
                }
              };
        
              console.log('dataClient', dataClient);
        
              return this._clientService.searchRUCPY(dataClient).then(
                async response => {
                  console.log('response RUC', response);
        
                  if(response.status){
                    this.client.clientName =  response.data.razonSocial;
                    this.client.clientStatus = 1;
                    this.client.clientDeleted = 0;
                    this.client.clientPhone = "00000000";
                    this.client.clientEmail = "info@clever.com";
                    this.client.clientAddress = "CIUDAD";
                    // this.client.clientDV = 0;
                    // this.client.clientTR = 0;
                    this.client.clientDOperacion = "PY";
        
                    this.insertNewClient = true;
                    this.recurrentClient = false;
                    this.viewBilling();
                  }
                  else{
                    this._utilsService.showNotification(3, 'Cliente no encontrado en Megapring PY');            
                  }
        
                },
                error => {
                  console.log('error RUC', error);
                }
              ).finally(() => {
                this.loading = false;
                this.isDisabled = false;
              });

            }
  
          },
        error => {
          console.log(error);
        }
        ).finally(() => {
          this.loading = false;
          this.isDisabled = false;
        });        

      }

      // // return this._clientService.getOneByNit(nit).then(
      // return this._clientService.getOneByCompanyNit(this.companyCode, nit).then(
      //   response => {
      //     // console.log(response.records)
      //     if (response.records.length > 0) {
      //       this.client = response.records[0];
      //       this.recurrentClient = true;
      //       this.insertNewClient = false;
      //       this.viewBilling();
      //       this._utilsService.showNotification(1, response.message);
      //     } else {            
      //       return this._clientService.searchNitSAT(nit, this.client.clientType).then(
      //         async response => {
      //           if (response.tipo_respuesta == 0) {
      //             //this.client.clientName = response.nombre[0];
      //             //console.log(response.nombre[0]);
      //             this.client.clientName =  response.nombre[0];
      //             this.client.clientStatus = 1;
      //             this.client.clientDeleted = 0;
      //             this.client.clientPhone = "00000000";
      //             this.client.clientEmail = "info@clever.com";
      //             this.client.clientAddress = "CIUDAD";

      //             this.insertNewClient = true;
      //             this.recurrentClient = false;
      //             this.viewBilling();
      //             this._utilsService.showNotification(4, "Cliente Nuevo");
      //           } else {
      //             this._utilsService.showNotification(3, response.listado_errores[0].error[0].desc_error[0]);
      //           }
      //         },
      //         error => {
      //           console.log(error);
      //         }
      //       );
      //     }
      //   },
      //   error => {
      //     console.log(error);
      //   }
      // ).finally(() => {
      //   this.loading = false;
      //   this.isDisabled = false;

      //   this.ValidarCF();
      // });
      
    }
  }

  async insertInvoice() {
    this.loading = true;
    this.isDisabled = true;
    this.disabled = true;

    
    const _data = JSON.parse(localStorage.getItem('data'));

    if(_data != undefined && !_data.isStoreOpen && this.OpenCash){
      swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se puede realizar una venta hasta que abra la caja....',
      })
      this.loading = false;
      return;
    }    

    console.log('TipoCliente -> ', this.tipoCliente);


    //Crear Cliente en la DB
    if (this.insertNewClient) {
      // Resolver problema con DATA BASE
      let nombre;
      nombre = await this.client.clientName.replace(/&/g, '&amp;');
      nombre = await this.client.clientName.replace(/'/g, '&apos;');
      nombre = await this.client.clientName.replace(/"/g, '&quot;');

      this.client.clientName = nombre;
      this.client.clientCredit = 0;
      this.client.clientStatus = 1;
      this.client.clientDeleted = 0;
      this.client.clientBlocked = 0;
      this.client.clientInterest = 0;
      this.client.clientDiscount = 0;
      this.client.clientCategory = 2;
      this.client.clientCreditTime = 0;
      this.client.clientCreditAmount = 0;
      this.client.clientCompanyCode = this.companyCode;
      this.client.clientType = this.tipoCliente;
      this.client.clientNameFrequent = '-';

      if (this.client.clientTaxDocument && this.client.clientName) {
        const response = await this._clientService.insert(this.client);
        this.client.clientCode = response.records[0].insertId;
      };
    }

    // Si es factura de pequeño contribuyente
    let transmitterType = "FACT";
    let transmitterMembership = "GEN";
    if (this.company.companyTaxToPay == 5) {
      transmitterType = "FPEQ";
      transmitterMembership = "PEQ";
    }

    // if(this.company.companyCode == 24){ //ETISA
    //   if (this.invoiceHeader.invoiceIDP > 0) {
    //     this.invoiceHeader.invoiceTax = 0;
    //     this.invoiceLine.forEach(e => {
    //       this.invoiceHeader.invoiceTax = parseFloat((this.invoiceHeader.invoiceTax + e.taxAmount).toFixed(2))
    //     });
    //   } else {
    //     this.invoiceHeader.invoiceTax = parseFloat(((this.invoiceHeader.invoiceTotal / this.taxToPay) * (this.taxToPay - 1)).toFixed(2))
    //   }
    // }
    // else{ //Resto de Empresas
    //   if (this.invoiceHeader.invoiceIDP > 0) {
    //     this.invoiceHeader.invoiceTax = 0;
    //     this.invoiceLine.forEach(e => {
    //       this.invoiceHeader.invoiceTax = parseFloat((this.invoiceHeader.invoiceTax + e.taxAmount).toFixed(4))
    //     });
    //   } else {
    //     this.invoiceHeader.invoiceTax = parseFloat(((this.invoiceHeader.invoiceTotal / this.taxToPay) * (this.taxToPay - 1)).toFixed(4))
    //   }
    // }    

    const hour = await this._utilsService.dateTime('HH:mm:ss');

    let FormaPagoTexto = "";
    if(this.tipoPago == 0){
      FormaPagoTexto = "Efectivo";
    }
    else if(this.tipoPago == 1){
      FormaPagoTexto = "Tarjeta";
    }
    else if(this.tipoPago == 1){
      FormaPagoTexto = "Crédito";
    }

    if(this.company.companyPaymentType == 0){
      await this.PaymentLine.push({
        typePayment: 0,
        NamePaymentType: 'Efectivo',
        MontoPayment: parseFloat((this.invoiceHeader.invoiceTotal).toFixed(4))
      });
    }

    let ADENDASUMMARY = undefined;

    let json;

    if(this.company.companyCode == 24){ //ETISA

      ADENDASUMMARY = {
        Valor1: this.OrdenCompra,
        Valor2: FormaPagoTexto,
        Valor3: this.invoiceHeader.invoiceExchangeRate == undefined ? 0 : this.invoiceHeader.invoiceExchangeRate,
        Valor4: this.invoiceHeader.invoiceCurrency
      };


      json = {
        "store": {
          "storeCode": this.storeCode
        },
        "user": {
          "userCode": this.userCode
        },
        "transmitter": {
          "transmitterMembership": transmitterMembership,
          "transmitterType": transmitterType,
          "transmitterEstablishmentCode": this.store.storeEstablishmentCode,
          "transmitterEmail": this.company.companyEmail,
          "transmitterTaxDocument": this.company.companyTaxDocument,
          "transmitterComercialName": this.store.storeName,
          "transmitterName": this.company.companyName,
          "transmitterAddress": this.store.storeAddress,
          "transmitterZipCode": this.store.storeZipCode,
          "transmitterMunicipality": this.store.storeMunicipality,
          "transmitterDepartment": this.store.storeDepartment,
          "transmitterCountry": 'PA',
          "transmitterPrefix": this.company.companyPrefix,
          "transmitterUser": this.company.companyPrefix,
          "transmitterKey": this.company.companyKey,
          "transmitterToken": this.company.companyToken,
          "transmitterPhraseCode": parseFloat(this.company.companyPhraseCode),
          "transmitterPhraseType": parseFloat(this.company.companyPhraseType)
        },
        "receiver": {
          "receiverAddress": this.client.clientAddress,
          "receiverCode": this.client.clientCode,
          "receiverDeleted": 0,
          "receiverEmail": this.client.clientEmail,
          "receiverName": this.client.clientName,
          "receiverStatus": 1,
          "receiverTaxDocument": this.client.clientTaxDocument,
          "receiverTypeTaxDocument": this.tipoCliente,
          "receiverZipCode": 0,
          "receiverCountry": "PA",
          "receiverDV": this.client.clientDV,
          "receiverTR": this.client.clientTR,
          "receiverDOperacion": this.client.clientDOperacion,
          "receiverProvincia": this.client.clientProvincia,
          "receiverDistrito": this.client.clientDistrito,
          "receiverCorregimiento": this.client.clientCorregimiento,
        },
        "invoice": {
          "invoiceCode": 1,
          "invoiceCurrency": this.invoiceHeader.invoiceCurrency,
          "invoiceChangeRate": this.invoiceHeader.invoiceExchangeRate == undefined ? 0 : this.invoiceHeader.invoiceExchangeRate,
          "invoiceTaxShortName": "IVA",
          // "invoiceDate": this.invoiceHeader.invoiceDate,
          "invoiceDate": this.invoiceHeader.invoiceDate + ' ' + hour,
          "invoiceInternSerial": this.invoiceHeader.invoiceInternSerial,
          "invoiceTaxValue": parseFloat((this.invoiceHeader.invoiceTax).toFixed(4)),
          "invoiceTotal": parseFloat((this.invoiceHeader.invoiceTotal).toFixed(4)),
          "invoiceOilTaxShortName": this.invoiceHeader.invoiceIDP > 0 ? "PETROLEO" : undefined,
          "invoiceOilTaxValue": parseFloat((this.invoiceHeader.invoiceIDP).toFixed(4)),
          "invoiceDuesQuantity": 0,
          "invoicepaymentType": this.tipoPago,
        },
        "phrase": this.company.phrase,
        "detail": this.invoiceLine,
        "paymentType": this.PaymentLine,
        "provider": this.company.companyCertifier == 0 ? "infile" : "megaprint",
        "serial": this.serialSelected,
        "addendum": ADENDASUMMARY,
        "salesPerson": this.SalesPerson
      };
  
      console.log(json);
  
      const logo = await this._companyService.getOne(this.companyCode);
      logo.records[0].companyLogoUrl != 'undefined' && (this.companyLogoUrl = logo.records[0].companyLogoUrl);

    }
    else{ //Resto de Empresas

      if(this.companyCode == 28){
        ADENDASUMMARY = {
          Valor1: this.NamePaymentType,
        };
      }

      if(this.company.companyTaxDocument == "107832135" || this.company.companyTaxDocument == "96561513"){
        
        console.log('this.ExentaInvoice', this.ExentaInvoice)
        if(this.ExentaInvoice){
          console.log('this.company.phrase', this.company.phrase);
          this.company.phrase.push({phraseStage: '1', phrase: '1'});
          this.company.phrase.push({phraseStage: '9', phrase: '4'});
        }

        ADENDASUMMARY = {
          Observaciones: this.invoiceHeader.invoiceCommentInvoice,
        };
      }

      if(this.company.companyTaxDocument == "108773167"){

        if(this.client.clientPhone == undefined || this.client.clientPhone == ""){
          this.client.clientPhone = "-";
        }

        ADENDASUMMARY = {
          Telefono: this.client.clientPhone,
          Valor1: this.NamePaymentType,
        };
      }

      json = {
        "store": {
          "storeCode": this.storeCode
        },
        "user": {
          "userCode": this.userCode,
          "userName": this.userName
        },
        "transmitter": {
          "transmitterMembership": transmitterMembership,
          "transmitterType": transmitterType,
          "transmitterEstablishmentCode": this.store.storeEstablishmentCode,
          "transmitterExpeditionPoint": 1,
          "transmitterEmail": this.company.companyEmail,
          "transmitterTaxDocument": this.company.companyTaxDocument,
          "transmitterComercialName": this.store.storeName,
          "transmitterName": this.company.companyName,
          "transmitterAddress": this.store.storeAddress,
          "transmitterZipCode": this.store.storeZipCode,
          "transmitterMunicipality": this.store.storeMunicipality,
          "transmitterDepartment": this.store.storeDepartment,
          "transmitterCountry": 'PA',
          "transmitterPrefix": this.company.companyPrefix,
          "transmitterUser": this.company.companyPrefix,
          "transmitterKey": this.company.companyKey,
          "transmitterToken": this.company.companyToken,
          "transmitterPhraseCode": parseFloat(this.company.companyPhraseCode),
          "transmitterPhraseType": parseFloat(this.company.companyPhraseType),
          "transmitterPhone": this.company.companyPhone,
        },
        "receiver": {
          "receiverAddress": this.client.clientAddress,
          "receiverCode": this.client.clientCode,
          "receiverDeleted": 0,
          "receiverEmail": this.client.clientEmail,
          "receiverName": this.client.clientName,
          "receiverStatus": 1,
          "receiverTaxDocument": this.client.clientTaxDocument,
          "receiverTypeTaxDocument": this.tipoCliente,
          "receiverZipCode": 0,
          "receiverCountry": "PY",
          "receiverPhone": this.client.clientPhone,
          "receiverDV": this.client.clientDV,
          "receiverTR": this.client.clientTR,
          "receiverDOperacion": this.client.clientDOperacion,
          "receiverProvincia": this.client.clientProvincia,
          "receiverDistrito": this.client.clientDistrito,
          "receiverCorregimiento": this.client.clientCorregimiento,
          "receiverDesProvincia": this.itemNameProvincia,
          "receiverDesDistrito": this.itemNameDistritos,
          "receiverDesCorregimiento": this.itemNameCorregimientos,
          "receiverCodeProvincia": this.idProvincia,
          "receiverCodeDistrito": this.idDistritos,
          "receiverCodeCorregimiento": this.idCorregimientos,
          "receiverCodeUbicacion": this.idProvincia + "-" + this.idDistritos + "-" + this.idCorregimientos,
        },
        "invoice": {
          "invoiceCode": 1,
          "invoiceCurrency": this.invoiceHeader.invoiceCurrency,
          "invoiceChangeRate": this.invoiceHeader.invoiceExchangeRate == undefined ? 0 : this.invoiceHeader.invoiceExchangeRate,
          "invoiceTaxShortName": "IVA",
          // "invoiceDate": this.invoiceHeader.invoiceDate,
          "invoiceDate": this.invoiceHeader.invoiceDate + ' ' + hour,
          "invoiceInternSerial": this.invoiceHeader.invoiceInternSerial,
          "invoiceTaxValue": parseFloat((this.invoiceHeader.invoiceTax).toFixed(4)),
          "invoiceTotal": parseFloat((this.invoiceHeader.invoiceTotal).toFixed(4)),
          "invoiceOilTaxShortName": this.invoiceHeader.invoiceIDP > 0 ? "PETROLEO" : undefined,
          "invoiceOilTaxValue": parseFloat((this.invoiceHeader.invoiceIDP).toFixed(4)),
          "invoiceDuesQuantity": 0,
          "invoicepaymentType": this.tipoPago,
          "invoiceCommentInvoice": this.invoiceHeader.invoiceCommentInvoice
        },
        "phrase": this.company.phrase,
        "detail": this.invoiceLine,
        "paymentType": this.PaymentLine,
        "provider": this.company.companyCertifier == 0 ? "infile" : "megaprint",
        "serial": this.serialSelected,
        "addendum": ADENDASUMMARY,
        "salesPerson": this.SalesPerson,
        "exenta": this.ExentaInvoice,
        "minStock": this.invoiceLineMinStock,
        "companySendStock": this.companySendStock,
        "logoUrl": ''
      };

      console.log(json);

      const logo = await this._companyService.getOne(this.companyCode);
      logo.records[0].companyLogoUrl != 'undefined' && (this.companyLogoUrl = logo.records[0].companyLogoUrl);
      json.logoUrl = this.companyLogoUrl || '';

    }

    // console.log(json);
    // this.loading = false;
    // this.isDisabled = false;
    // Insertar Venta
    if (this.company.companyCertifier == 0) { //INFILE
      this._invoiceService.insertBillingExenta(json).then(
        async (response) => {
          if (response.result) {
            console.log('Response PY', response);

            this._utilsService.showNotification(1, response.message);
            this._utilsService.showNotification(1, response.records.infileServiceResponse.data.msgRes);

            this.fel = response.infileBody;
            this.felDetail = response.infileBody.detail;
            this.dte = {
              serie: response.records.infileServiceResponse.data.CDC,
              noFactura: response.records.infileServiceResponse.data.protConsLote,
              autorizacion: response.invoiceAuthorization,
              certificador: "DNIT",
              nitCertificador: 12345678,
              fechaCertificacion: response.records.infileServiceResponse.data.fecProc
            }
            console.log("QR", response.records.infileServiceResponse.data.qrUrl);

            this.downloadUrlS3(response.records.infileServiceResponse.data.signedUrl, response.records.infileServiceResponse.data.CDC, "xml");
            if (response.records.infileServiceResponse.data.signedUrlPdf) {
              this.downloadUrlS3(response.records.infileServiceResponse.data.signedUrlPdf, response.records.infileServiceResponse.data.CDC, "pdf");
            }
            this.continue();

            // if(response.records.invoiceGetFile.status){
            //   this._utilsService.showNotification(1, response.records.invoiceGetFile.message);
            //   window.open(response.records.invoiceGetFile.url.url, '_self', 'width=600,height=600');
            // }
            // else{
            //   this._utilsService.showNotification(3, response.records.invoiceGetFile.message);
            // }

            // let base64Data = response.records.infileServiceResponse.data.xmlData;
            // let fileName = response.records.infileServiceResponse.data.CDC + '.xml'

            // this.downloadPdf(base64Data, fileName);

            this.viewBeginning();
            this.cleanModel();

            this._utilsService.showNotification(1, response.message);

            if(this.company.companyExistenceFlag === 0 && this.invoiceLineMinStock.length > 0){

              if(this.companySendStock == 1){
                this.sendEmail_StockMin();
              }                          

            }

          } else {
            this._utilsService.showNotification(3, response.errorMessage);
          }
        },
        error => {
          this._utilsService.showNotification(2, error);
          console.log(error);
        }
      ).finally(() => {
        this.loading = false;
        this.isDisabled = false;
        this.disabled = false;        
      });
    }
    else if (this.company.companyCertifier == 1) { //Megaprint
      this._invoiceService.insertBilling(json).then(
        (response) => {
          if (response.result) {
            // console.log(response);
            if (this.company.companyInvoiceFuel == 1 || this.company.companyPDFType == 1) {
              this.fel = response.megaprintBody;
              this.felDetail = response.megaprintBody.detail;
              let dte = response.records.megaprintServiceResponse.jsonXml['dte:GTDocumento']['dte:SAT'][0]['dte:DTE'][0]['dte:Certificacion'][0];
              this.dte = {
                serie: dte['dte:NumeroAutorizacion'][0]['Serie'][0],
                noFactura: dte['dte:NumeroAutorizacion'][0]['Numero'][0],
                autorizacion: dte['dte:NumeroAutorizacion'][0]['_'],
                certificador: dte['dte:NombreCertificador'][0],
                nitCertificador: dte['dte:NITCertificador'][0],
                fechaCertificacion: dte['dte:FechaHoraCertificacion'][0]
              }
              this.viewPrint();
            } else {
              var pdfResult = response.invoicePdf;
              let pdfWindow = window.open("")
              pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe>")
              this.viewBeginning();
              this.cleanModel();
            }
            this._utilsService.showNotification(1, response.message);

            if(this.company.companyExistenceFlag === 0 && this.invoiceLineMinStock.length > 0){
              
              if(this.companySendStock == 1){
                this.sendEmail_StockMin();
              }

            }

          } else {
            this._utilsService.showNotification(3, response.errorMessage);
          }
        },
        error => {
          this._utilsService.showNotification(2, error);
          console.log(error);
        }
      ).finally(() => {
        this.loading = false;
        this.isDisabled = false;
        this.disabled = false;
      });
    }
    this.isDisabled = false;
    this.disabled = false;
    this.insertNewClient = false;
    
    if(this.OpenCash){
      this.isInventoryView = true;
      this.getAll(this.storeCode);

      var amountsByPayType = JSON.parse(localStorage.getItem('salesAmounts'));
      this.PaymentLine.forEach(element => {
        amountsByPayType.paymentType.forEach(payType => {
          console.log(amountsByPayType.paymentType)
          if(payType.id == element.typePayment){
            payType.amount += element.MontoPayment
          }
        });
      });

      localStorage.setItem('salesAmounts', JSON.stringify(amountsByPayType))
    }
  }

  async downloadUrlS3(urlFirmada, nombreFile, format){
    const response = await fetch(urlFirmada);
    const blob = await response.blob();

    const urlBlob = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = urlBlob;
    link.download = nombreFile + "." + format;
    link.click();

    window.URL.revokeObjectURL(urlBlob);
  }

  downloadPdf(base64Data: string, fileName: string = 'factura.pdf') {
    // console.log('base64Data', base64Data);
    // Convertir base64 a un blob de tipo PDF
    const byteCharacters = atob(base64Data);
    const byteNumbers = Array.from(byteCharacters).map(char => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
  
    // Crear un link temporal y hacer clic para descargar
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  
    // Liberar memoria
    window.URL.revokeObjectURL(link.href);
  }

  sendEmail_StockMin(){

    let detail = this.invoiceLineMinStock;
    console.log('MinStock detail', detail);
    console.log('Emails', this.companyAddressNotif);
    // const pdfHmtl = this._printService.minStockEmail(detail);
    // const pdfHmtl = "<html><head><title>Reporte de Stock Minimo</title></head><body><h1>Reporte de Stock Minimo</h1><table><thead><tr><th>Codigo</th><th>Descripcion</th></tr></thead><tbody><tr><td>1</td><td>2</td></tr></tbody></table></body></html>";
    let tableRows = '';

    detail.forEach(item => {
      tableRows += `<tr><td>${item.itemCode}</td><td>${item.description}</td><td>${item.Minstock}</td></tr>`;
    });

    const pdfHtml = `
      <html>
        <head>
          <title>Reporte de Stock Minimo</title>
        </head>
        <body>
          <h1>Reporte de Stock Minimo</h1>
          <p>Se ha llegado al stock minimo de los siguientes productos:</p>
          <table style="border: 1px solid black;">
            <thead>
              <tr style="border: 1px solid black;">
                <th>Codigo</th>
                <th>Descripcion</th>
                <th>Min. Stock</th>
              </tr>
            </thead>
            <tbody style="border: 1px solid black;">
              ${tableRows}
            </tbody>
          </table>
        </body>
      </html>
    `;

    //ENVIAR PREVENTA POR CORREO
    const data_to_send = {
      email: this.companyAddressNotif,
      presale_number: "1",
      html_content: pdfHtml,
    };

    this._invoiceService
      .sendEmail_Presale(data_to_send)
      .then(
        async (response) => {
          if (response) {
            this._utilsService.showNotification( 1, "Notificación enviada correctamente");
          }
        },
        (error) => {
          console.log(error);
          //this.loading = false;
          //this.disabled = false;
        }
      );

  }

  // GET ALL INVENTORY
  getAll(storeCode) {
    this.loading = true;
    // console.log(storeCode, "este es el store code para nail center")
    return this._inventoryService.getAllByStore(storeCode).then(
      response => {
        if (response.result) {
          //this.inventoryList = response.records;
          this.temp = response.records;
          console.log(this.inventoryList);
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  Unidades(num){

    switch(num)
    {
        case 1: return "UN";
        case 2: return "DOS";
        case 3: return "TRES";
        case 4: return "CUATRO";
        case 5: return "CINCO";
        case 6: return "SEIS";
        case 7: return "SIETE";
        case 8: return "OCHO";
        case 9: return "NUEVE";
    }

    return "";
  }//Unidades()

  Decenas(num){

    let decena = Math.floor(num/10);
    let unidad = num - (decena * 10);

    switch(decena)
    {
        case 1:
            switch(unidad)
            {
                case 0: return "DIEZ";
                case 1: return "ONCE";
                case 2: return "DOCE";
                case 3: return "TRECE";
                case 4: return "CATORCE";
                case 5: return "QUINCE";
                default: return "DIECI" + this.Unidades(unidad);
            }
        case 2:
            switch(unidad)
            {
                case 0: return "VEINTE";
                default: return "VEINTI" + this.Unidades(unidad);
            }
        case 3: return this.DecenasY("TREINTA", unidad);
        case 4: return this.DecenasY("CUARENTA", unidad);
        case 5: return this.DecenasY("CINCUENTA", unidad);
        case 6: return this.DecenasY("SESENTA", unidad);
        case 7: return this.DecenasY("SETENTA", unidad);
        case 8: return this.DecenasY("OCHENTA", unidad);
        case 9: return this.DecenasY("NOVENTA", unidad);
        case 0: return this.Unidades(unidad);
    }
  }//Unidades()

  DecenasY(strSin, numUnidades) {
      if (numUnidades > 0)
      return strSin + " Y " + this.Unidades(numUnidades)

      return strSin;
  }//DecenasY()

  Centenas(num) {
      let centenas = Math.floor(num / 100);
      let decenas = num - (centenas * 100);

      switch(centenas)
      {
          case 1:
              if (decenas > 0)
                  return "CIENTO " + this.Decenas(decenas);
              return "CIEN";
          case 2: return "DOSCIENTOS " + this.Decenas(decenas);
          case 3: return "TRESCIENTOS " + this.Decenas(decenas);
          case 4: return "CUATROCIENTOS " + this.Decenas(decenas);
          case 5: return "QUINIENTOS " + this.Decenas(decenas);
          case 6: return "SEISCIENTOS " + this.Decenas(decenas);
          case 7: return "SETECIENTOS " + this.Decenas(decenas);
          case 8: return "OCHOCIENTOS " + this.Decenas(decenas);
          case 9: return "NOVECIENTOS " + this.Decenas(decenas);
      }

      return this.Decenas(decenas);
  }//Centenas()

  Seccion(num, divisor, strSingular, strPlural) {
      let cientos = Math.floor(num / divisor)
      let resto = num - (cientos * divisor)

      let letras = "";

      if (cientos > 0)
          if (cientos > 1)
              letras = this.Centenas(cientos) + " " + strPlural;
          else
              letras = strSingular;

      if (resto > 0)
          letras += "";

      return letras;
  }//Seccion()

  Miles(num) {
      let divisor = 1000;
      let cientos = Math.floor(num / divisor)
      let resto = num - (cientos * divisor)

      let strMiles = this.Seccion(num, divisor, "UN MIL", "MIL");
      let strCentenas = this.Centenas(resto);

      if(strMiles == "")
          return strCentenas;

      return strMiles + " " + strCentenas;
  }//Miles()

  Millones(num) {
      let divisor = 1000000;
      let cientos = Math.floor(num / divisor)
      let resto = num - (cientos * divisor)

      let strMillones = this.Seccion(num, divisor, "UN MILLON DE", "MILLONES DE");
      let strMiles = this.Miles(resto);

      if(strMillones == "")
          return strMiles;

      return strMillones + " " + strMiles;
  }//Millones()

  NumeroALetras(num) {
      var data = {
          numero: num,
          enteros: Math.floor(num),
          centavos: (((Math.round(num * 100)) - (Math.floor(num) * 100))),
          letrasCentavos: "",
          letrasMonedaPlural: 'GUARANIES',//"PESOS", 'Dólares', 'Bolívares', 'etcs'
          letrasMonedaSingular: 'GUARANIES', //"PESO", 'Dólar', 'Bolivar', 'etc'

          letrasMonedaCentavoPlural: "CENTAVOS",
          letrasMonedaCentavoSingular: "CENTAVO"
      };

      console.log('numeroletras',data);
      console.log('centavos',data.centavos);

      let millones = this.Millones(data.centavos);
      console.log('millones',millones);    

      if(data.centavos > 0){
        data.letrasCentavos = "CON "
        if (data.centavos == 1){
          millones += " " + data.letrasMonedaCentavoSingular;
        }
        else{
          millones += " " + data.letrasMonedaCentavoPlural;
        }
      }
      data.letrasCentavos += millones;
      console.log('millones->',data.letrasCentavos);
      

      // if (data.centavos > 0) {
      //     data.letrasCentavos = "CON " + (function (){
      //         if (data.centavos == 1)
      //             return this.Millones(data.centavos) + " " + data.letrasMonedaCentavoSingular;
      //         else
      //             return this.Millones(data.centavos) + " " + data.letrasMonedaCentavoPlural;
      //         })();
      // };

      if(data.enteros == 0)
          return "CERO " + data.letrasMonedaPlural + " " + data.letrasCentavos;
      if (data.enteros == 1)
          return this.Millones(data.enteros) + " " + data.letrasMonedaSingular + " " + data.letrasCentavos;
      else
          return this.Millones(data.enteros) + " " + data.letrasMonedaPlural + " " + data.letrasCentavos;
  }//NumeroALetras()

  // GET ONE INVENTORY
  viewFunction($event) {
    $event.preventDefault();
    let series;
    this.activeRow.inventorySerialFlag == 1 ? series = 'SI' : series = 'NO';

    swal.fire({
      title: "Item:",
      imageUrl: `https://storage.googleapis.com/nail-center/Imagenes/${this.activeRow.inventoryBusinessCode}.jfif`,
      imageHeight: 300,
      html:
        '<div class="text-left">' +
        "<b>Código: </b>" +
        this.activeRow.inventoryBusinessCode +
        "<br>" +
        "<b>Nombre: </b>" +
        this.activeRow.inventoryName +
        "<br>" +
        "<b>Series: </b>" +
        series +
        "<hr>" +
        "<b>Precio Venta: </b>" +
        this.activeRow.inventoryPrice +
        "<br>" +
        "<b>Precio Minimo de Venta: </b>" +
        this.activeRow.inventoryMinPrice +
        "<br>" +
        "<b>Precio con Descuento: </b>" +
        this.activeRow.inventoryPriceDiscount +
        "<br>" +
        "<b>Precio de Promoción: </b>" +
        this.activeRow.inventorySalePrice +
        "<hr>" +
        "<b>Stock: </b>" +
        this.activeRow.inventoryQuantity +
        "<br>" +
        "<b>Stock Mínimo: </b>" +
        this.activeRow.inventoryMin +
        "<br>" +
        "<b>Stock Máximo: </b>" +
        this.activeRow.inventoryMax +
        "<hr>" +
        "<b>Cód. de Orden: </b>" +
        this.activeRow.inventoryPurchaseDetail +
        "<br>" +
        "<b>Descripción: </b>" +
        this.activeRow.inventoryDescription +
        "<br></div>",
      customClass: {
        confirmButton: "btn btn-success",
      },
      width: 650,
      confirmButtonText: "Aceptar",
      buttonsStyling: false,
    });
  }
  
  onActivate(event) {
    this.activeRow = event.row;
  }

  async printLetter() {
    const pdfWindow = window.open("", 'Factura', '_blank');
    let NCE = "";
    if(this.tipoCliente == 0){
      NCE = "NIT: "
    }
    else if(this.tipoCliente == 1){
      NCE = "CUI: "
    }
    else if(this.tipoCliente == 2){
      NCE = "EXT: "
    }

    const css = `
    <!DOCTYPE html>
    <html lang="es">
    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Factura Electrónica Paraguay</title>
      <style>
        :root {
          --page-w: 794px;
          --border: #1f1f1f;
          --bg: #efefef;
          --blue: #5d8fe4;
        }
        * { box-sizing: border-box; }
        body {
          margin: 0;
          background: #dcdcdc;
          font-family: Arial, Helvetica, sans-serif;
          color: #111;
        }
        .page {
          width: var(--page-w);
          min-height: 1123px;
          margin: 12px auto;
          background: var(--bg);
          padding: 20px 14px 16px;
        }
        .box { border: 2px solid var(--border); }
        .top {
          display: grid;
          grid-template-columns: 67% 33%;
        }
        .issuer {
          display: grid;
          grid-template-columns: 180px 1fr;
          min-height: 192px;
          align-items: center;
        }
        .logo-wrap {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 12px 8px;
        }
        .logo-wrap img { width: 150px; height: auto; object-fit: contain; }
        .issuer-text {
          text-align: center;
          padding: 10px 2px;
          font-size: 11px;
          line-height: 1.25;
        }
        .issuer-text .strong { font-size: 14px; }
        .issuer-text .space { margin-top: 8px; }
        .bill-info {
          padding: 14px 16px 8px;
          position: relative;
          font-size: 14px;
          line-height: 1.2;
        }
        .bill-info .row { margin-bottom: 18px; }
        .bill-info .label { font-weight: 700; font-size: 18px; }
        .bill-info .value { font-weight: 400; font-size: 14px; }
        .bill-info .title {
          text-align: center;
          font-size: 24px;
          font-weight: 700;
          margin-top: 6px;
          margin-bottom: 34px;
        }
        .bill-info .serial {
          text-align: center;
          font-size: 14px;
          margin-top: 4px;
        }
        .receiver-title {
          display: grid;
          grid-template-columns: 1fr 220px;
          align-items: center;
          border: 2px solid var(--border);
          border-top: none;
          padding: 7px 14px 6px;
          font-size: 12px;
          font-weight: 700;
        }
        .receiver-title .center {
          text-align: center;
          font-size: 18px;
          letter-spacing: .2px;
        }
        .receiver-title .right { text-align: right; }
        .info-row {
          display: grid;
          border-left: 1px solid #7a7a7a;
          border-right: 1px solid #7a7a7a;
          border-bottom: 1px solid #7a7a7a;
          min-height: 30px;
          align-items: center;
          font-size: 13px;
          background: var(--bg);
        }
        .info-row.two { grid-template-columns: 1fr 210px; }
        .info-row.two-eq { grid-template-columns: 1fr 1fr; }
        .info-row > div {
          padding: 4px 6px;
          border-right: 1px solid #7a7a7a;
        }
        .info-row > div:last-child { border-right: none; }
        .fld { font-weight: 700; font-size: 12px; }
        .fld.big { font-size: 15px; }
        .muted { font-weight: 400; }

        table {
          width: 100%;
          border-collapse: collapse;
        }
        .detail {
          margin-top: 1px;
          border: 1px solid #7a7a7a;
          font-size: 11px;
        }
        .detail th,
        .detail td {
          border: 1px solid #7a7a7a;
          padding: 4px 6px;
          vertical-align: top;
        }
        .detail thead th {
          text-align: center;
          font-size: 12px;
          font-weight: 700;
          height: 40px;
        }
        .detail .qty { width: 11%; text-align: center; }
        .detail .desc { width: 40%; }
        .detail .price { width: 12%; text-align: center; }
        .detail .tax { width: 10.5%; text-align: center; }
        .detail tbody td { height: 27px; }
        .detail tbody tr.fill td { height: 350px; }
        .detail tfoot td {
          font-size: 12px;
          padding: 6px 5px;
        }
        .bold { font-weight: 700; }
        .right { text-align: right; }
        .center { text-align: center; }

        .qr-section {
          display: grid;
          grid-template-columns: 128px 1fr;
          column-gap: 18px;
          align-items: start;
          margin-top: 10px;
        }
        .qr img {
          width: 118px;
          height: 118px;
          object-fit: cover;
          display: block;
        }
        .validation {
          font-size: 12px;
          padding-top: 16px;
        }
        .validation .link {
          color: #5d8fe4;
          font-weight: 700;
          text-decoration: none;
          display: inline-block;
          margin-top: 3px;
        }
        .cdc-bar {
          margin-top: 14px;
          background: var(--blue);
          color: #0c0c0c;
          min-height: 30px;
          display: flex;
          align-items: center;
          padding: 0 10px;
          font-size: 13px;
          width: 78%;
          font-weight: 700;
        }
        .cdc-bar .lbl { font-size: 18px; margin-right: 10px; font-weight: 400; }
        .footer {
          margin-top: 8px;
          font-size: 11px;
          line-height: 1.35;
        }
        .footer .main {
          font-size: 12px;
          margin-bottom: 3px;
        }
        @media print {
          body { background: #fff; }
          .page { margin: 0 auto; }
        }
      </style>
    </head>
    `;

    var html = `
      <body>
        <div class="page">
          <section class="top box">
            <div class="issuer">
              <div class="logo-wrap">
                <img src="${this.companyLogoUrl}">
              </div>
              <div class="issuer-text">
                <div class="strong">MAGOLD SEMIJOYAS E.A.S</div>
                <div class="strong">MAGOLD SEMIJOYAS E.A.S</div>
                <div>COMERCIO AL POR MENOR DE OTROS PRODUCTOS EN COMERCIOS</div>
                <div>NO ESPECIALIZADOS</div>
                <div class="space">AVENIDA AVIADORES DEL CHACO, 2050 EDIF. WORLD TRADE</div>
                <div>CENTER, TORRE 4 PISO 14 - BARRIO YKUA SATI</div>
                <div class="space">Establecimiento:&nbsp;&nbsp; 003</div>
                <div>Teléfono:&nbsp; +595 982 974700</div>
                <div>Punto de expedición:&nbsp;&nbsp; 001</div>
                <div>Cel.: +595 982 974700</div>
              </div>
            </div>
            <div class="bill-info" style="border-left: 2px solid var(--border);">
              <div class="row"><span class="label">TIMBRADO No.:</span> <span class="value">17442091</span></div>
              <div class="row"><span class="label">Valido desde:</span> <span class="value">23-08-2024</span></div>
              <div class="row"><span class="label">RUC:</span> <span class="value">80127989-5</span></div>
              <div class="title">FACTURA:</div>
              <div class="serial">${this.fel.invoice.invoiceInternNumber}</div>
            </div>
          </section>

          <section class="receiver-title">
            <div class="center">DATOS RECEPTOR</div>
            <div class="right">DV del RUC Emisor:&nbsp;&nbsp;&nbsp; <span class="muted">5</span></div>
          </section>

          <div class="info-row two">
            <div><span class="fld big">FECHA EMISIÓN:</span> <span class="muted">${this.pipeFecha.transform(this.fel.invoice.invoiceDate, 'dd-MM-yyy')}</span></div>
            <div class="right"><span class="fld">Condición de venta:</span> <span class="muted">Contado</span></div>
          </div>
          <div class="info-row">
            <div><span class="fld big">RAZÓN SOCIAL RECEPTOR:</span> <span class="muted">${this.fel.receiver.receiverName}</span></div>
          </div>
          <div class="info-row two-eq">
            <div><span class="fld big">R.U.C&nbsp; RECEPTOR:</span> <span class="muted">${this.fel.receiver.receiverTaxDocument}-${this.fel.receiver.receiverDV}</span></div>
            <div><span class="fld big">MONEDA:</span> <span class="muted">Guarani</span></div>
          </div>
          <div class="info-row two">
            <div><span class="fld big">DIRECCIÓN RECEPTOR:</span> <span class="muted">${this.fel.receiver.receiverAddress}</span></div>
            <div><span class="fld big">TELÉFONO:</span> <span class="muted">${this.fel.receiver.receiverPhone}</span></div>
          </div>

          <table class="detail">
            <thead>
              <tr>
                <th class="qty">CANTIDAD</th>
                <th class="desc">DESCRIPCIÓN DEL PRODUCTO</th>
                <th class="price">PRECIO<br>UND.</th>
                <th class="tax">EXENTA</th>
                <th class="tax">5%</th>
                <th class="tax">10%</th>
              </tr>
            </thead>
            <tbody>`;

        for (const e of this.felDetail) {
          html += `
          <tr>
            <td class="center">${this._pipeNumero.transform(e.quantity, '1.2-2')}</td>
            <td>${e.description}</td>
            <td class="center">${this._pipeNumero.transform(e.unitPrice, '1.2-2')}</td>
            <td class="center">${this._pipeNumero.transform(e.total, '1.2-2')}</td>
            <td class="center">0,00</td>
            <td class="center">0,00</td>
          </tr>`
        };

    html += `
              <tr class="fill">
                <td></td><td></td><td></td><td></td><td></td><td></td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="5" class="bold">SUB-TOTALES:</td>
                <td class="right">${this._pipeNumero.transform(this.fel.invoice.invoiceTotal, '1.2-2')}</td>
              </tr>
              <tr>
                <td colspan="5"><span class="bold">SON GUARANÍES:</span>&nbsp;&nbsp;&nbsp; ${this.TotalLetras}</td>
                <td class="right">${this._pipeNumero.transform(this.fel.invoice.invoiceTotal, '1.2-2')}</td>
              </tr>
              <tr>
                <td colspan="2" class="bold">TOTAL EXENTAS: ${this._pipeNumero.transform(this.fel.invoice.invoiceTotal, '1.2-2')}</td>
                <td colspan="2" class="center bold">TOTAL 5%:</td>
                <td class="center bold">TOTAL10%:<span class="muted"></span></td>
                <td class="center bold">TOTAL IVA:<span class="muted"></span></td>
              </tr>
            </tfoot>
          </table>

          <section class="qr-section">
            <div class="qr">              
              <img src="data:image/png;base64,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" alt="Código QR" />              
            </div>
            <div class="validation">
              <div>Consulte la validez de esta Factura Electrónica con el número de CDC impreso abajo en:</div>
              <a class="link" href="https://ekuatia.set.gov.py/consultas/">https://ekuatia.set.gov.py/consultas/</a>
              <div class="cdc-bar"><span class="lbl">CDC:</span> ${this.dte.serie}</div>
            </div>
          </section>

          <section class="footer">
            <div class="main">ESTE DOCUMENTO ES UNA REPRESENTACIÓN GRÁFICA DE UN DOCUMENTO ELECTRONICO (XML)</div>
            <div>Si su documento electrónico presenta algun error, podrá solicitar la modificación dentro de las 48 horas</div>
            <div>siguientes de la emisión de este comprobante.</div>
          </section>
        </div>
      </body>
      </html>
    `;

    /*var html = `
    <head><title>Factura Clever "${this.company.companyName + ' - ' + this.storeName}"</title></head>
    <body style="width: 21cm; height: 27cm; margin: auto; font-family: sans-serif, system-ui, monospace;"> 
      <div style="border: 2px solid #2CA8FF; border-radius: 10px; width: auto;">
        <table style="width: 100%;">
              <tr>
                  <td rowspan="5" style="width: 19%;">
                      <img style="width: 110px; margin:10px auto; display:block;" src="${this.companyLogoUrl}">
                  </td>
                  <th style="width: 62%; font-size: 19px; text-align: cent  er;">                      
                      ${this.fel.transmitter.transmitterComercialName}
                  </th>
                  <td style="width: 19%; font-size: 10px;">
                      Vendedor: ${this.userName}
                  </td>
              </tr>
              <tr>
                  <td style="text-align: center;">
                    ${this.fel.transmitter.transmitterName}
                  </td>
                  <td style="font-size: 10px;">FACTURA ELECTRONICA</td>
              </tr>
              <tr>
                  <td style="text-align: center;">
                      RUC: ${this.fel.transmitter.transmitterTaxDocument}
                  </td>
                  <td>CDC: ${this.dte.serie}</td>
              </tr>
              <tr>
                  <td style="text-align: center;">
                      Tel: ${this.store.storePhone}<br>
                      ${this.fel.transmitter.transmitterAddress}. ${this.fel.transmitter.transmitterMunicipality}, ${this.fel.transmitter.transmitterDepartment}
                  </td>
                  <td>Lote DNIT: ${this.dte.noFactura}</td>
              </tr>
              <tr>
                  <th style="text-align: center;">FACTURA</th>
                  <td>Fecha: ${this.pipeFecha.transform(this.fel.invoice.invoiceDate, 'dd-MM-yyy')}</td>
              </tr>
        </table>
      </div>
      <br>
      <div style="border: 2px solid #2CA8FF; border-radius: 10px 10px 0px 0px; width: auto; min-height: 750px" >
        <table cellspacing="0" cellpadding="0" style="width: 100%;">
            <tr style="max-height: 15px;">
              <td colspan="4"> Nombre: ${this.fel.receiver.receiverName}</td>
              <td colspan="3"> RUC: ${this.fel.receiver.receiverTaxDocument}</td>
            </tr>
            <tr style="max-height: 15px;">
              <td colspan="7"> Dirección: ${this.fel.receiver.receiverAddress}</td>
            </tr>
            <tr style="font-size: 11px; text-align: center;">
              <th class="brDescr">CANTIDAD</th>
              <th class="brDescr">TIPO</th>
              <th class="brDescr" style="width: 320px;">DESCRIPCIÓN</th>
              <th class="brDescr">PRECIO UNI. ₲</th>
              <th class="brDescr">IMPUESTO ₲</th>
              <th class="brDescr">DESCUENTO ₲</th>
              <th class="brDescr" style="width: 120px;">TOTAL ₲</th>
            </tr>`;
    
    for (const e of this.felDetail) {
      html += `<tr">
        <td style="text-align: center; "> ${this._pipeNumero.transform(e.quantity, '1.2-2')}</td>
        <td style="text-align: center;"> ${e.isService}</td>
        <td>${e.description}</td>
        <td style="text-align: right;"> ${this._pipeNumero.transform(e.unitPrice, '1.2-2')}</td>
        <td style="text-align: right;"> ${this._pipeNumero.transform(e.taxAmount, '1.2-2')}</td>
        <td style="text-align: right;"> ${this._pipeNumero.transform(e.discount, '1.2-2')}</td>
        <td style="text-align: right;"> ${this._pipeNumero.transform(e.total, '1.2-2')}</td>
        </tr>`
    };

    html += `          
        </table>
      </div>
      <div style="border: 2px solid #2CA8FF; border-radius: 0px 0px 10px 10px; width: auto;">
        <table cellspacing="0" style="width: 100%;">
              <tr>
                <td colspan="7" style="text-align: center; font-size: 10px;"></td>
              </tr>
              <tr style="height: 30px;">
                <td class="brCompl" style="max-width: 22px; padding-left: 5px;">Total en Letras:</td>
                  <td class="brCompl" style="font-size: 10px max-width: 65px; text-align: left;">${this.pipeLetra.transform(this.fel.invoice.invoiceTotal)}</td>
                  <th style="font-size: 14px; max-width: 65px; text-align: right; border-top: 1px solid  #2CA8FF;">
                    TOTAL: ₲ ${this._pipeNumero.transform(this.fel.invoice.invoiceTotal, '1.2-2')}
                  </th>
              </tr>
          </table>
      </div> 
      <br>
      <table style="border: 2px solid #2CA8FF; border-radius: 10px; width: 100%;" padding: 10px;" >
          <tr><td>
            No. de Autorización: ${this.dte.autorizacion}<br>
            Fecha de Certificación: ${this.dte.fechaCertificacion}  
          </td></tr>
          <tr><td style="text-align: center">Certificador: ${this.dte.certificador}. Nit: ${this.dte.nitCertificador}</td></tr>
      </table>
    </body>`;*/

    await pdfWindow.document.write(css + html);  //setTimeout( () => {pdfWindow.window.open()}, 1100)
    this.continue();
  }

  // Limpiar Campos
  async cleanModel() {    
    
    this.addAmount = true;
    this.isDisabled = false;
    this.disabled = false;
    this.insertNewClient = false;
    this.recurrentClient = false;
    this.client = {} as Client;
    this.invoiceHeader = {} as InvoiceHeader;
    this.invoiceDetail = {} as InvoiceDetail;
    this.invoiceLine = [];
    this.invoiceLineMinStock = [];
    this.moneda = "₲";
    this.petroleo = null;
    this.taxOilAmount = 0;
    this.taxOilCode = null;
    this.invoiceHeader.invoiceIDP = 0;
    this.invoiceHeader.invoiceTax = 0;
    this.invoiceHeader.invoiceTotal = 0;
    this.invoiceHeader.invoiceCoin = 0;
    this.invoiceHeader.invoiceCurrency = 'GTQ';
    this.invoiceDetail.invoiceDetailType = 'B';    
    this.invoiceDetail.invoiceDetailQuantity = 1;
    this.invoiceHeader.invoiceInternSerial = 'A';
    this.invoiceHeader.paymentType = 0;
    this.tipoPago = 0;
    this.invoiceHeader.invoiceDate = this.nowDay;
    this.client.clientType = 0;
    this.OrdenCompra = "0";

    this.jumpSerial = false;
    this.idp = 0;
    this.subIdp = 0;
    this.subsidio = 0;
    this.subsidioTemp = 0;
    //this.taxToPay = 0;
    this.priceType = 1;
    this.PaymentLine = [];
    this.MontoTotalPayment = 0;
    this.serialSelected = [];

    if (this.isParamsUrl) {
      this.router.navigate([], { relativeTo: this.activatedRoute });
    }

    await this.getAll(this.storeCode);
  }

  ///////////////////////PANTALLAS///////////////////////
  viewBeginning() {
    this.isBeginning = true;
    this.isBilling = false;
    this.isPrintT = false;
    this.isPrintL = false;
    console.log('Tipo ', this.client.clientType);
    this.client.clientType = 0;
    this.tipoCliente = 0;    
    this.cleanModel();
  }

  viewBilling() {
    this.isBeginning = false;
    this.isBilling = true;
    this.isPrintT = false;
    this.isPrintL = false;
  }

  viewPrint() {
    this.isBeginning = false;
    this.isBilling = false;
    console.log("Imrpimiendo");
    console.log("Imrpimiendo...", this.company.companyInvoicePrint);
    // this.company.companyInvoicePrint === 1 ? this.isPrintT = true : this.isPrintL = true;
    this.company.companyInvoicePrint === 1 ? this.isPrintT = true : this.printLetter();
  }

  viewCF() {
    this.isBeginning = true;
    this.isBilling = true;
    this.isPrintT = false;
    this.isPrintL = false;
    this.disabled = true;
    this.isDisabled = false;
    console.log('TP CF-> ', this.tipoCliente);
    this.client.clientType = this.tipoCliente;
  }

  ValidarCF() {
    /*J11 - Validar CF*/
    console.log('Total Factura', parseFloat((this.invoiceHeader.invoiceTotal).toFixed(4)));
    console.log(this.client.clientTaxDocument);

    if(0 != 0){
      if(this.client.clientTaxDocument == "CF"){
        this._utilsService.showNotification(5, "No puede facturar como CF, el monto es mayor a 2500");
        this.viewCF();
      }
      else{
        this.disabled = false;
      }
    }
  }

  continue() {
    this.viewBeginning();
    this.cleanModel();
  }

  // PRINT
  printTest() {
    printJS({
      printable: "printSection",
      type: "html",
      style: "#printSection{width: 224px; text-align: center};",
    });
  }
}
